document.addEventListener('DOMContentLoaded', () => {
    //All accessibility js code should be here

    function cartWidgetAccessibility() {
        const cartSection = document.getElementById('shopify-section-cart_widget');
        const cartCanvas = document.getElementById('nt_cart_canvas');
        const isMobile = window.innerWidth < 768;
        

        if(!cartCanvas) return;
        cartCanvas.setAttribute('role', 'dialog')
        cartCanvas.setAttribute('aria-modal', 'true')
        cartCanvas.setAttribute('aria-label', 'Cart');
        const cartIsVisible = cartCanvas.classList.contains('act_opened');
        cartCanvas.setAttribute('aria-hidden', !cartIsVisible ? 'false' : 'true');

        const cartLink = document.querySelector('.icon_cart a');
        const innerModalsClose = cartCanvas.querySelectorAll('.mini_cart_tool > div[role="button"]');

        const hideObserver = new MutationObserver(() => {
                if(cartCanvas.querySelectorAll('.mini_cart_info').length > 0) {
                    initHiddenElements(cartCanvas);
                    hideObserver.disconnect();
                }
            });
            hideObserver.observe(cartCanvas, {
                subtree: true,
                childList: true
            });

        innerModalsClose.forEach(btn => {
            const callback = () => {
                if(!isMobile) {
                    btn.click();
                }
                const data = btn.getAttribute('data-id');
                const activeData = cartCanvas.querySelector(`.pe_none[data-id="${data}"]`);
                const allFocusableElements = getFocusableElementsReuseCart(activeData);
                removeHiddenElement(allFocusableElements);
                setTimeout(() => {
                    trapFocusReuse(activeData, btn, allFocusableElements, true);
                }, 500);
            }
            btn.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') callback();
            });
            btn.addEventListener('click', () => callback());
        });

        function openCartModal(btnOpenModal) {
            const overlay = document.querySelector('.mask-overlay');
            if (overlay) {
                setTimeout(() => {
                    if(!isMobile) {
                        overlay.click();
                    }
                    document.querySelectorAll('.mini_cart_item').forEach(item => {
                        const titleLink = item.querySelector('.mini_cart_title:not([applied])');
                        if(titleLink) {
                            titleLink.setAttribute('href', titleLink.getAttribute('href') + '?')
                            titleLink.setAttribute('applied', 'true');
                        }
                        const next = item.nextElementSibling;
                        const editLink = next.querySelector('.cart_ac_edit');
                        if(editLink) {
                            editLink.setAttribute('href', editLink.getAttribute('href') + '/');
                            editLink.setAttribute('tabindex', '0');
                        }
                    });
                    
                    const active = cartCanvas.classList.contains('current_hover');
                    active ? cartCanvas.classList.remove('current_hover') : cartCanvas.classList.add('current_hover');
                    if (!active) {
                        const itemsContainer = cartCanvas.querySelector('.mini_cart_items');
                        let activeContainer = undefined;
                        const emptyCart = cartCanvas.querySelector('.empty:not(.dn)');
                        let emptyVisible = window.getComputedStyle(emptyCart) ? window.getComputedStyle(emptyCart).display === 'block' : false;
                        const innerModalsClose = cartCanvas.querySelector('.mini_cart_note.is_nt_op, .mini_cart_ship.is_nt_op, .mini_cart_dis.is_nt_op');

                        if (emptyCart && emptyVisible) {
                            activeContainer = emptyCart;
                            const allFocusableElements = getFocusableElementsReuseCart(emptyCart)
                            removeHiddenElement(allFocusableElements);
                            trapFocusReuse(emptyCart, btnOpenModal, allFocusableElements);

                        } else if (itemsContainer && itemsContainer.querySelectorAll(':scope > *').length) {
                            activeContainer = itemsContainer;

                            if (!innerModalsClose) {
                                const tools = cartCanvas.querySelector('.mini_cart_tool');
                                const footer = cartCanvas.querySelector('.mini_cart_footer');

                                const allFocusableElements = [
                                    ...getFocusableElementsReuseCart(itemsContainer),
                                    ...getFocusableElementsReuseCart(tools),
                                    ...getFocusableElementsReuseCart(footer),
                                    ...cartCanvas.querySelectorAll('.btn-cart, .btn-checkout')
                                ];

                                removeHiddenElement(allFocusableElements);
                                trapFocusReuse(cartCanvas, undefined, allFocusableElements);
                            } else {
                                activeContainer = innerModalsClose;
                                const allFocusableElements = getFocusableElementsReuseCart(innerModalsClose)
                                removeHiddenElement(allFocusableElements);
                                trapFocusReuse(innerModalsClose, btnOpenModal, allFocusableElements);
                            }
                        }

                        const offEscape = onEscape(() => {
                            cartCanvas.classList.remove('current_hover');
                        });

                        function onEscape(handler) {
                            function listener(e) {
                                if (e.key === 'Escape' || e.key === 'Esc' || e.code === 'Escape') {
                                    handler(e);
                                }
                            }
                            activeContainer.addEventListener('keydown', listener);
                            return () => activeContainer.removeEventListener('keydown', listener);
                        }
                    }
                }, 100);
            }
        }

        function removeHiddenElement(allFocusableElements) {
            allFocusableElements.forEach(item => {
                item.removeAttribute('aria-hidden');
                if (item.getAttribute('role') === 'button') {
                    item.setAttribute('tabindex', '0');
                } else {
                    item.removeAttribute('tabindex');
                }
            });
        }

        cartLink.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                openCartModal(cartLink);
            }
        });

        cartLink.addEventListener('click', (e) => {
            openCartModal(cartLink);
        });

        if (!cartSection || !cartCanvas) {
            return;
        }

        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.attributeName === 'class') {
                    const cartIsVisible = cartCanvas.classList.contains('act_opened');
                    cartCanvas.setAttribute('aria-hidden', cartIsVisible ? 'false' : 'true');
                    if (!cartIsVisible) {
                        cartLink.focus();
                        initHiddenElements(cartCanvas);
                    }
                }
            });
        });

        observer.observe(cartCanvas, {
            attributes: true
        });

        function toggleVisibility(container, isVisible) {
            isVisible ? container.removeAttribute('tabindex') : container.setAttribute('tabindex', '-1');
            container.querySelectorAll('a[href], input:not([type="hidden"]), select, textarea, button, [tabindex]').forEach(element => {
                element.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
                isVisible ? element.removeAttribute('tabindex') : element.setAttribute('tabindex', '-1');
            });
        }

        function initHiddenElements(cartCanvas) {
            toggleVisibility(cartCanvas, false);
            cartCanvas.setAttribute('aria-hidden', 'true');
            const canvas = document.querySelector('#nt_search_canvas');
            canvas.setAttribute('aria-hidden', 'true');
            toggleVisibility(canvas, false);
        }
    }

    cartWidgetAccessibility();

    function addErrorMessage() {
        // Add asterisk to placeholder
        function setupForm(form) {
            const emailInput = form.querySelector('input[type="email"]');
            if (emailInput && emailInput.placeholder) {
                const currentPlaceholder = emailInput.placeholder;
                if (!currentPlaceholder.includes('*')) {
                    emailInput.placeholder = currentPlaceholder + ' *';
                }
            }
        }

        const existingForms = document.querySelectorAll('footer form.klaviyo_sub_frm');
        existingForms.forEach(setupForm);

        // Intercept Klaviyo error event
        document.body.addEventListener('klaviyo.subscribe.error', function (e) {
            const form = e.target;
            const errorContainer = form.querySelector('.shopify-error.error_message');

            if (errorContainer) {
                errorContainer.textContent = 'Enter an email address in the format example@example.com';
                errorContainer.classList.remove('dn');
            }
        });
    }

    addErrorMessage();

    function fixRebuyWidget() {
        let observer = new MutationObserver(() => {
            const rebuyContainer = document.querySelector('.rebuy-widget');
            if (!rebuyContainer) return;
            changeHeading(rebuyContainer);

            observer.disconnect();
        });



        function changeHeading(rebuyContainer) {
            const h3 = rebuyContainer.querySelector('h3.primary-title');

            if (h3) {
                const h2 = document.createElement('h2');
                h2.className = h3.className;
                h2.textContent = h3.textContent;
                h3.replaceWith(h2);
            }
        }

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    fixRebuyWidget();

    function addPaginationLabels() {
        const pagination = document.querySelector('.boost-sd__pagination');
        if (!pagination) return;

        const allPageButtons = pagination.querySelectorAll('.boost-sd__pagination-number');

        allPageButtons.forEach((button, index) => {
            const pageNum = parseInt(button.textContent.trim());
            const isDisabled = button.classList.contains('boost-sd__pagination-number--disabled');
            const hasActiveClass = button.classList.contains('boost-sd__pagination-number--active');

            if (!isNaN(pageNum) && !isDisabled) {
                const newLabel = `Page ${pageNum}`;
                button.setAttribute('aria-label', newLabel);
                button.setAttribute('aria-current', hasActiveClass ? 'true' : 'false');
            } else {
                button.setAttribute('aria-hidden', 'true');
                button.setAttribute('tabindex', '-1');
            }
        });

        const isEllipsis = Array.from(allPageButtons).some(item => item.classList.contains('boost-sd__pagination-number--disabled'));
        const activeElement = Array.from(allPageButtons).find(item => item.classList.contains('boost-sd__pagination-number--active'));

        const prevButton = pagination.querySelector('.boost-sd__pagination-button--prev');
        if (prevButton) {
            if (!isEllipsis) {
                prevButton.setAttribute('aria-hidden', 'true');
                prevButton.setAttribute('tabindex', '-1');
            } else {
                if (activeElement.innerText !== '1') {
                    prevButton.setAttribute('aria-label', `Page ${(+activeElement.innerText) - 1}`);
                }
            }
        }


        const nextButton = pagination.querySelector('.boost-sd__pagination-button--next');
        if (nextButton) {
            if (!isEllipsis) {
                nextButton.setAttribute('aria-hidden', 'true');
                nextButton.setAttribute('tabindex', '-1');
            } else {
                const nextElement = activeElement.nextElementSibling;
                if (nextElement && (+nextElement.innerText)) {
                    nextButton.setAttribute('aria-label', `Page ${(+nextElement.innerText)}`)
                }

            }
        }

        if (!pagination.hasAttribute('role')) {
            pagination.setAttribute('role', 'navigation');
            pagination.setAttribute('aria-label', 'Pagination');
        }
    }

    function fixFallSavingsAccessibility() {
        const observer = new MutationObserver(() => {
            const popupContainer = document.querySelector('[data-testid="POPUP"]');
            if (!popupContainer) return;

            const richTexts = popupContainer.querySelectorAll('[id^="rich-text"]');
            const popupTitle = richTexts[0]?.querySelector('span');
            if (popupTitle) {
                const h1 = document.createElement('h1');
                h1.style.cssText = popupTitle.style.cssText;
                h1.textContent = popupTitle.textContent;
                popupTitle.parentNode.replaceChild(h1, popupTitle);
            }

            const errorMessage = popupContainer.querySelector('span[role="alert"]');
            if (errorMessage) {
                errorMessage.textContent = 'Enter an email address in the format example@example.com';
            }

            setTimeout(() => {
                const emailInput = popupContainer.querySelector('input[type="email"]');
                if (emailInput && emailInput.placeholder) {
                    const currentPlaceholder = emailInput.placeholder;
                    if (!currentPlaceholder.includes('*')) {
                        emailInput.placeholder = currentPlaceholder + ' *';
                    }
                }

                const buttons = popupContainer.querySelectorAll('button[type="button"]:not(.klaviyo-close-form)');
                const signUpButton = buttons[0];
                const richTexts = popupContainer.querySelectorAll('[id^="rich-text"]');
                const disclaimer = richTexts[richTexts.length - 1];
                if (signUpButton && disclaimer && disclaimer.id) {
                    signUpButton.setAttribute('aria-describedby', disclaimer.id);
                }

                const disclaimerLinks = popupContainer.querySelectorAll('p a[href]');
                disclaimerLinks.forEach(link => {
                    const linkText = link.textContent.trim();
                    if (linkText === 'Privacy Policy' || linkText === 'Terms') {
                        link.style.textDecoration = 'underline';
                    }
                });
            }, 300);

            const errorObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === 1) {
                            const errorMsg = node.querySelector('span[role="alert"]') ||
                                (node.matches && node.matches('span[role="alert"]') ? node : null);
                            if (errorMsg) {
                                errorMsg.textContent = 'Enter an email address in the format example@example.com';
                            }

                            const links = node.querySelectorAll('p a[href]') ||
                                (node.matches && node.matches('p a[href]') ? [node] : []);
                            links.forEach(link => {
                                const linkText = link.textContent.trim();
                                if (linkText === 'Privacy Policy' || linkText === 'Terms') {
                                    link.style.textDecoration = 'underline';
                                }
                            });
                        }
                    });
                });
            });

            errorObserver.observe(popupContainer, {
                childList: true,
                subtree: true
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    fixFallSavingsAccessibility();

    function fixThumbnailAccessibility() {
        if (!window.location.pathname.includes('/collections/') && !window.location.pathname.includes('/search')) return;

        let productList = null;

        function getProductList() {
            productList = document.querySelector('.boost-sd__product-list');
            return productList;
        }

        function addLabelToSearch() {
            const input = document.querySelector('.boost-sd__search-form-wrapper .boost-sd__search-form-input');
            if (!input) return;

            if (!document.querySelector('#search_label')) {
                const label = document.createElement('label');
                label.classList.add('visually-hidden');
                label.setAttribute('for', input.id)
                label.innerText = 'Search';
                label.id = 'search_label';
                input.after(label);
            }
        }

        function addButtonRoleToGridIcons() {
            const gridViewIndex = 0;
            const btns = document.querySelectorAll('.boost-sd__view-as .boost-sd__view-as-icon');

            btns.forEach((btn, index) => {
                if (index === 0) {
                    btn.closest('.boost-sd__toolbar-item').removeAttribute('aria-label');
                    btn.closest('.boost-sd__toolbar-item').removeAttribute('role');
                }
                const isActive = btn.classList.contains('boost-sd__view-as-icon--active')
                btn.setAttribute('role', 'button');
                btn.setAttribute('aria-pressed', isActive);
                btn.setAttribute('tabindex', '0');
                btn.removeAttribute('aria-checked');
                btn.setAttribute('aria-label', isActive ? 'Grid view' : 'List view');
                btn.addEventListener('click', () => {
                    setTimeout(() => {
                        btns.forEach((item) => {
                            item.setAttribute('aria-pressed', item.classList.contains('boost-sd__view-as-icon--active'));
                        });
                    }, 100);
                });

                btn.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        btn.click();
                    }
                });
            });
            document.querySelectorAll('.boost-sd__view-as .boost-sd__tooltip-content').forEach((btn, index) => {
                btn.setAttribute('aria-hidden', 'true');
            });
        }

        function restructureProductItem(item) {
            if (item.classList.contains('structure-fixed')) return;

            const imageLink = item.querySelector('.boost-sd__product-image');
            const titleLink = item.querySelector('.boost-sd__product-link:not(.boost-sd__product-image)');

            if (imageLink && titleLink && imageLink.href === titleLink.href) {
                const originalHref = titleLink.href;
                const titleElement = titleLink.querySelector('.boost-sd__product-title');

                if (titleElement) {
                    const originalColor = window.getComputedStyle(titleElement).color;

                    const span = document.createElement('span');
                    span.className = titleLink.className;
                    span.innerHTML = titleLink.innerHTML;
                    span.style.cursor = 'pointer';

                    const newTitleElement = span.querySelector('.boost-sd__product-title');
                    if (newTitleElement) {
                        newTitleElement.style.transition = '.3s';
                    }

                    span.addEventListener('mouseenter', function () {
                        const title = this.querySelector('.boost-sd__product-title');
                        if (title) title.style.color = '#ffc662';
                    });

                    span.addEventListener('mouseleave', function () {
                        const title = this.querySelector('.boost-sd__product-title');
                        if (title) title.style.color = originalColor;
                    });

                    span.addEventListener('click', function (e) {
                        e.preventDefault();
                        window.location.href = originalHref;
                    });

                    titleLink.replaceWith(span);
                    item.classList.add('structure-fixed');
                }
            }
        }

        function clearImageAlts() {
            const productImages = document.querySelectorAll('.boost-sd__product-item .boost-sd__product-image-img[alt]:not([alt=""])');
            productImages.forEach(img => {
                img.alt = '';
            });
        }

        function addAccessibilityRoles() {
            const list = getProductList();
            if (list && !list.hasAttribute('role')) {
                list.setAttribute('role', 'list');
                list.setAttribute('aria-label', getCollectionName());
            }

            const productItems = document.querySelectorAll('.boost-sd__product-item:not([role])');
            productItems.forEach(item => {
                item.setAttribute('role', 'listitem');
            });
        }

        function addQuickViewLabels() {
            const quickViewButtons = document.querySelectorAll('.boost-sd__button--quick-view:not([aria-label])');
            quickViewButtons.forEach(button => {
                if (!button.getAttribute('aria-label')) {
                    button.setAttribute('aria-label', 'Quick view');
                }
            });
        }

        function getCollectionName() {
            const h1Element = document.querySelector('.boost-sd__header-title');
            if (h1Element && h1Element.textContent.trim()) {
                return `${h1Element.textContent.trim()} collection`;
            }
            return "Products collection";
        }

        function initAccessibilityObserver() {
            const list = getProductList();
            if (!list) {
                setTimeout(initAccessibilityObserver, 250);
                return;
            }

            let productObserver;
            let processTimeout;

            const processProductChanges = () => {
                clearTimeout(processTimeout);

                processTimeout = setTimeout(() => {
                    const itemsToProcess = document.querySelectorAll('.boost-sd__product-item:not(.structure-fixed)');
                    itemsToProcess.forEach(restructureProductItem);

                    clearImageAlts();
                    addAccessibilityRoles();
                    addQuickViewLabels();
                    addButtonRoleToGridIcons();
                    addLabelToSearch();
                    addPaginationLabels();
                }, 250);
            };

            productObserver = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList' || mutation.type === 'attributes') {
                        processProductChanges();
                        return;
                    }
                }
            });

            processProductChanges();

            productObserver.observe(document.body, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class']
            });
        }

        function fixSelectedFilterItems() {
            if (!window.location.pathname.includes('/collections/') && !window.location.pathname.includes('/search')) return;

            const observer = new MutationObserver(() => {
                const container = document.querySelector('.boost-sd__refine-by-vertical-refine-by');

                if (!container) return;

                const title = container.querySelector('.boost-sd__refine-by-vertical-refine-by-heading');
                const listContainer = container.querySelector('.boost-sd__refine-by-vertical-refine-by-list');

                title.id = 'current_filters_title';

                listContainer.setAttribute('aria-labelledby', title.id);
                listContainer.setAttribute('role', 'list');

                listContainer.querySelectorAll('.boost-sd__refine-by-vertical-refine-by-item').forEach(element => {
                    replaceChildElement(element);
                });


                document.querySelectorAll('.boost-sd__refine-by-vertical-refine-by button').forEach(element => {
                    element.addEventListener('click', () => {
                        verifyActiveFilterlistener(observer);
                    });
                });
            });

            observer.observe(document.body, {
                subtree: true,
                childList: true
            });


            function verifyActiveFilterlistener(observer) {
                setTimeout(() => {
                    const activeFiltersQty = document.querySelectorAll('.boost-sd__refine-by-vertical-refine-by button').length;
                    if (activeFiltersQty === 0) {
                        observer.observe(document.body, {
                            subtree: true,
                            childList: true
                        });
                    }
                }, 500);
            }

            function replaceChildElement(element) {
                const btnText = element.querySelector('.boost-sd__refine-by-vertical-refine-by-type');
                btnText.setAttribute('aria-hidden', 'true');
                const btnLabelText = 'Remove filter, ' + btnText.innerText;

                element.setAttribute('tabindex', '-1');
                element.setAttribute('role', 'listitem');

                const button = element.querySelector('svg');
                button.setAttribute('tabindex', '0');
                button.setAttribute('role', 'button');
                button.setAttribute('aria-label', btnLabelText);

                button.addEventListener('click', () => element.click());
                element.removeAttribute('aria-label');
            }

            function observeChildren(container, firstObserver) {
                const childObserver = new MutationObserver(mutations => {
                    mutations.forEach(mutation => {
                        mutation.addedNodes.forEach(node => {
                            if (node.nodeType === 1) {
                                replaceChildElement(node);
                            };
                        });
                    });
                });

                childObserver.observe(container, { childList: true, subtree: true });

                const parent = container.parentNode;
                if (parent.parentNode) {
                    const parentObserver = new MutationObserver(mutations => {
                        mutations.forEach(mutation => {
                            mutation.removedNodes.forEach(node => {
                                if (node === parent) {
                                    verifyActiveFilterlistener(firstObserver);
                                    parentObserver.disconnect();
                                    childObserver.disconnect();
                                }
                            });
                        });
                    });
                    parentObserver.observe(parent.parentNode, { childList: true });
                }
            }
        }
        fixSelectedFilterItems();

        initAccessibilityObserver();
    }

    fixThumbnailAccessibility();

    function onAllChildrenReady(parentSelector, childSelector, callback) {
        const parents = document.querySelectorAll(parentSelector);
        if (!parents.length) return;

        const readyParents = new Set();
        const allParentsMap = new Map();

        parents.forEach(parent => {
            allParentsMap.set(parent, false);

            // Check if the content already exists.
            if (parent.querySelector(childSelector)) {
                readyParents.add(parent);
                allParentsMap.set(parent, true);
            } else {
                const observer = new MutationObserver(() => {
                    if (parent.querySelector(childSelector)) {
                        readyParents.add(parent);
                        allParentsMap.set(parent, true);
                        observer.disconnect();

                        if (readyParents.size === parents.length) {
                            callback(Array.from(allParentsMap.keys()));
                        }
                    }
                });
                observer.observe(parent, { childList: true, subtree: true });
            }
        });

        if (readyParents.size === parents.length) {
            callback(Array.from(allParentsMap.keys()));
        }
    }

    function fixModalProduct(element, prevSibling) {
        const id = element.getAttribute("data-opennt");
        const container = document.querySelector(id);
        if (!container) {
            console.warn('[Accessibility] Modal container not found for selector:', id);
            return;
        }

        let lazyImg = container.querySelector(".product-image.lazyload, .product-image.lazyloaded");
        if (!lazyImg) {
            console.warn('[Accessibility] Modal image not found for selector:', id);
            return;
        }
            const productTitle = container.querySelector('.product-title a');
            productTitle.id = 'popup-'+id;

        setTimeout(() => {
            const dialog = document.querySelector('.mfp-wrap');
            const modalContainer = container.querySelector('.pin__popup .product');
            if (dialog) {
                modalContainer.removeAttribute('aria-labelledby');
                modalContainer.removeAttribute('role');
                dialog.setAttribute('role', 'dialog');
                dialog.setAttribute('aria-labelledby', productTitle.id);
            } else {
                modalContainer.setAttribute('role', 'dialog');
                modalContainer.setAttribute('aria-labelledby', productTitle.id);
                modalContainer.tabIndex = '-1';
                modalContainer.focus();
                }
        }, 500);

        const onImageReady = () => {
            const hoverButtons = container.querySelector('.hover_button');
            let hideHoverButtonsFn = null;

            container.querySelectorAll('.product-image a').forEach(link => {
                link.setAttribute('aria-describedby', productTitle.id)
            })

            if(hoverButtons) {
                hoverButtons.querySelectorAll('.nt_add_w > a:not([applied]), .nt_add_w > span:not([applied]), .nt_add_cp > a:not([applied]), .nt_add_cp > span:not([applied])').forEach(link => {
                    link.setAttribute('applied', 'true');
                    setTimeout(() => {
                        const text = link.querySelector('.tt_txt');
                        if (!text) return
                        const updateLabel = () => link.setAttribute('aria-label', text.textContent);
                        updateLabel();
                        link.addEventListener('click', () => {
                            setTimeout(() => updateLabel(), 300);
                        });
                        link.addEventListener('keydown', (e) => {
                            if (e.key === 'Enter') setTimeout(() => updateLabel(), 300);
                        });
                    }, 200);
                });
            }

            const rating = container.querySelector('.jdgm-prev-badge__stars');
            if(rating) {
                rating.setAttribute('aria-label', `${rating.getAttribute('data-score')} out of 5 stars`);
                rating.setAttribute('role', 'img');
                rating.removeAttribute('tabindex');
            }

            const price = container.querySelector('.price');
            if(price) {
                price.id = 'price-'+id;
                productTitle.setAttribute('aria-describedby', price.id);
            }

            if (hoverButtons && !hoverButtons.dataset.accessibilityEnhanced) {
                hoverButtons.dataset.accessibilityEnhanced = 'true';
                hoverButtons.style.visibility = 'visible';
                hoverButtons.classList.add('op__0');

                const focusables = hoverButtons.querySelectorAll('a, button, [role="button"]');
                focusables.forEach(control => {
                    control.setAttribute('tabindex', '0');
                    control.setAttribute('role', 'button');
                });

                const showHoverButtons = () => {
                    hoverButtons.classList.add('focus-visible');
                    hoverButtons.classList.remove('op__0');
                    hoverButtons.style.opacity = '1';
                    hoverButtons.style.pointerEvents = 'auto';
                };

                const hideHoverButtons = () => {
                    hoverButtons.classList.remove('focus-visible');
                    hoverButtons.classList.add('op__0');
                    hoverButtons.style.opacity = '0';
                    hoverButtons.style.pointerEvents = 'none';
                };

                hideHoverButtons();

                focusables.forEach(control => {
                    control.addEventListener('focus', showHoverButtons);
                    control.addEventListener('blur', () => {
                        requestAnimationFrame(() => {
                            if (!hoverButtons.contains(document.activeElement)) {
                                hideHoverButtons();
                            }
                        });
                    });
                });

                const hoverTarget = hoverButtons.closest('.product-inner') || hoverButtons.parentElement;
                if (hoverTarget && !hoverTarget.dataset.hoverButtonsBound) {
                    hoverTarget.addEventListener('mouseenter', showHoverButtons);
                    hoverTarget.addEventListener('mouseleave', () => {
                        if (!hoverButtons.contains(document.activeElement)) {
                            hideHoverButtons();
                        }
                    });
                    hoverTarget.dataset.hoverButtonsBound = 'true';
                }

                hoverButtons.__showHoverButtons = showHoverButtons;
                hoverButtons.__hideHoverButtons = hideHoverButtons;
                hideHoverButtonsFn = hideHoverButtons;
            } else if (hoverButtons) {
                hideHoverButtonsFn = hoverButtons.__hideHoverButtons || (() => {
                    hoverButtons.classList.add('op__0');
                    hoverButtons.style.opacity = '0';
                    hoverButtons.style.pointerEvents = 'none';
                    hoverButtons.style.visibility = 'visible';
                    hoverButtons.classList.remove('focus-visible');
                });
                hideHoverButtonsFn();
            }

            const productImage = container.querySelector('.product-image');
            if (productImage && !productImage.hasAttribute('tabindex')) {
                productImage.setAttribute('tabindex', '0');
            }

            const productLink = container.querySelector('.product-image a');
            if (productLink) {
                productLink.setAttribute('tabindex', '-1');
                productLink.setAttribute('aria-hidden', 'true');
            }

            const stars = container.querySelector('.jdgm-prev-badge__stars');
            if (stars) {
                stars.removeAttribute('role');
                stars.removeAttribute('tabindex');
            }

            const pinType = container.closest('.pin__type');
            const desktopPopup = container.querySelector('.pin__popup');

            const checkForModal = () => {
                const mfpWrap = document.querySelector('.mfp-wrap.mfp-ready');

                if (mfpWrap) {
                    trapFocus(mfpWrap);

                    const cleanupModal = () => {
                        hideHoverButtonsFn?.();
                        if (mfpWrap.__trapFocusHandler) {
                            mfpWrap.removeEventListener('keydown', mfpWrap.__trapFocusHandler);
                            delete mfpWrap.__trapFocusHandler;
                            delete mfpWrap.dataset.trapFocusBound;
                        }
                        document.removeEventListener("keydown", handleEsc);
                    };

                    function handleEsc(event) {
                        if (event.key === "Escape" || event.key === "Esc") {
                            cleanupModal();
                            setTimeout(() => {
                                prevSibling?.focus();
                            }, 500);
                        }
                    }
                    document.addEventListener("keydown", handleEsc);

                    const modalCloseButton = mfpWrap.querySelector('.mfp-close');
                    if (modalCloseButton) {
                        console.log('Setting tabindex for modal close button');
                        modalCloseButton.addEventListener('click', () => {
                                const escEvent = new KeyboardEvent('keydown', {
                                    key: 'Escape',
                                    code: 'Escape',
                                    keyCode: 27, // legacy
                                    which: 27,   // legacy
                                    bubbles: true,
                                    cancelable: true
                                });

                                document.dispatchEvent(escEvent);
                        });
                        modalCloseButton.addEventListener('keydown', (e) => {
                            if(e.key === 'Enter') {
                                const escEvent = new KeyboardEvent('keydown', {
                                    key: 'Escape',
                                    code: 'Escape',
                                    keyCode: 27, // legacy
                                    which: 27,   // legacy
                                    bubbles: true,
                                    cancelable: true
                                });

                                document.dispatchEvent(escEvent);
                            }
                        })
                    }

                    const modalObserver = new MutationObserver((mutations) => {
                        mutations.forEach((mutation) => {
                            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                                if (mfpWrap.classList.contains('mfp-removing')) {
                                    cleanupModal();
                                    modalObserver.disconnect();
                                    setTimeout(() => {
                                        prevSibling?.focus();
                                    }, 100);
                                }
                            }
                        });
                    });

                    modalObserver.observe(mfpWrap, {
                        attributes: true,
                        attributeFilter: ['class']
                    });
                } else if (pinType) {
                    if (desktopPopup) {
                        desktopPopup.setAttribute('inert', '');
                    }

                    const waitForOpened = () => {
                        if (pinType.classList.contains('pin__opened')) {

                            if (desktopPopup && !desktopPopup.dataset.trapFocusBound) {
                                desktopPopup.removeAttribute('inert');
                                trapFocus(desktopPopup);

                                const cleanupDesktopModal = () => {
                                    hideHoverButtonsFn?.();
                                    if (desktopPopup.__trapFocusHandler) {
                                        desktopPopup.removeEventListener('keydown', desktopPopup.__trapFocusHandler);
                                        delete desktopPopup.__trapFocusHandler;
                                        delete desktopPopup.dataset.trapFocusBound;
                                    }
                                    document.removeEventListener("keydown", handleDesktopEsc);
                                    pinTypeObserver.disconnect();
                                    desktopPopup.setAttribute('inert', '');
                                };

                                function handleDesktopEsc(event) {
                                    if (event.key === "Escape" || event.key === "Esc") {
                                        document.body.click();
                                        cleanupDesktopModal();
                                        setTimeout(() => {
                                            prevSibling?.focus();
                                        }, 300);
                                    }
                                }
                                document.addEventListener("keydown", handleDesktopEsc);

                                const pinTypeObserver = new MutationObserver((mutations) => {
                                    mutations.forEach((mutation) => {
                                        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                                            if (!pinType.classList.contains('pin__opened')) {
                                                cleanupDesktopModal();
                                                setTimeout(() => {
                                                    prevSibling?.focus();
                                                }, 100);
                                            }
                                        }
                                    });
                                });

                                pinTypeObserver.observe(pinType, {
                                    attributes: true,
                                    attributeFilter: ['class']
                                });
                            }
                        } else {
                            setTimeout(waitForOpened, 50);
                        }
                    };

                    waitForOpened();
                } else {
                    setTimeout(checkForModal, 50);
                }
            };

            setTimeout(checkForModal, 100);
        };

        if (lazyImg.classList.contains('lazyloaded')) {
            onImageReady();
        } else {
            const observer = new MutationObserver(() => {
                if (lazyImg.classList.contains('lazyloaded')) {
                    onImageReady();
                    observer.disconnect();
                }
            });
            observer.observe(lazyImg, { attributes: true, attributeFilter: ['class'] });
        }
    }

        onAllChildrenReady("[id^='pin_mfp_']", ".product-title a", (parents) => {
        const parentMap = {};
        parents.forEach(p => {
            parentMap[p.id] = p;
        });
        const isModalActive = window.innerWidth < 1367;
        document.querySelectorAll("[data-opennt]").forEach((element) => {
            const targetId = element.getAttribute("data-opennt").substring(1);
            const parent = parentMap[targetId];

            if (parent) {
                const titleModal = parent.querySelector(".product-title a");
                if (titleModal) {
                    const prevSibling = element.previousElementSibling;
                    if(isModalActive) {
                        prevSibling.setAttribute('aria-hidden', 'true');
                    } else {
                        element.setAttribute('aria-hidden', 'true');
                    }


                    const activeElement = isModalActive ? element : prevSibling;
                    if (activeElement) {
                        activeElement.setAttribute("tabindex", "0");
                        activeElement.setAttribute("role", "button");
                        activeElement.setAttribute("aria-label", `Open ${titleModal.textContent.trim()} modal`);

                        // element.addEventListener('click', (e) => {
                        //     e.preventDefault();
                        //     prevSibling.click();
                        // });

                        activeElement.addEventListener('keydown', (e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                activeElement.click();
                            }
                        });

                        // prevSibling.addEventListener('keydown', (e) => {
                        //     if (e.key === 'Enter') {
                        //         e.preventDefault();
                        //         prevSibling.click();
                        //     }
                        // });

                        activeElement.addEventListener('click', () => {
                            fixModalProduct(element, activeElement);
                        });
                    } else {
                        console.warn('[Accessibility] No previous sibling found for data-opennt element', element);
                    }
                }

                const h3Title = parent.querySelector(".product-title");
                if (h3Title && h3Title.tagName === 'H3') {
                    const div = document.createElement('div');
                    div.className = h3Title.className + ' h3';
                    div.innerHTML = h3Title.innerHTML;
                    h3Title.replaceWith(div);
                }
            }
        });
    });

    function trapFocusReuse(container, btnOpenModal, focusableElements, hasBtnBack) {
        let focusables = [];
        if (focusableElements) {
            focusables = focusableElements;
        } else {
            focusables = getFocusableElementsReuse(container);
        }

        if (focusables.length === 0) return;

        // Focus first element
        focusables[0].focus();

        container.addEventListener('keydown', (e) => {
            if (e.key !== 'Tab') return;

            const first = focusables[0];
            const last = focusables[focusables.length - 1];

            if (e.shiftKey) {
                if (document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                if (document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        });

        let btnsBack = undefined;


        if (hasBtnBack) {
            btnsBack = container.querySelectorAll('.btn_back');
            btnsBack.forEach(btnClick => {
                btnClick.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter') {
                        btnClick.click();
                        btnOpenModal.focus();
                    }
                });
                btnClick.addEventListener('click', () => {
                    btnClick.click();
                    btnOpenModal.focus();
                });
            });
        }

        const offEscape = onEscape(() => {
            if (btnOpenModal) {
                const btn = btnOpenModal.querySelector('a');
                if (btn) {
                    btn.focus();
                } else {
                    if (hasBtnBack) {
                        btnsBack[0].click();
                        btnOpenModal.focus();
                    } else {
                        btnOpenModal.focus();
                    }
                }

            }
        });


        function onEscape(handler) {
            function listener(e) {
                if (e.key === 'Escape' || e.key === 'Esc' || e.code === 'Escape') {
                    handler(e);
                }
            }
            container.addEventListener('keydown', listener);
            return () => container.removeEventListener('keydown', listener);
        }
    }

    function getFocusableElementsReuse(container) {
        return Array.from(
            container.querySelectorAll(
                `
                    a[href]:not([tabindex="-1"]),
                    button:not([disabled]):not([tabindex="-1"]),
                    input:not([disabled]):not([type="hidden"]),
                    select:not([disabled]),
                    textarea:not([disabled]),
                    [tabindex]:not([tabindex="-1"])
                    `
            )
        );
    }

    function getFocusableElementsReuseCart(container) {
        return Array.from(
            container.querySelectorAll(
                `
                    a[href],
                    [role="button"]
                    button:not([disabled]),
                    input:not([disabled]):not([type="hidden"]),
                    select:not([disabled]),
                    textarea:not([disabled]),
                    [tabindex]
                    `
            )
        );
    }

    function trapFocus(container) {
        if (!container) return;

        const trapTarget = (container.classList?.contains('mfp-wrap') && container)
            || container.closest?.('.mfp-wrap')
            || container;

        if (!document.contains(trapTarget)) {
            requestAnimationFrame(() => trapFocus(container));
            return;
        }

        const focusables = getFocusableElements(trapTarget);
        if (!focusables.length) {
            requestAnimationFrame(() => trapFocus(container));
            return;
        }

        const getVisibleFocusables = () =>
            getFocusableElements(trapTarget).filter((element) => {
                const styles = getComputedStyle(element);
                return styles.visibility !== 'hidden' && styles.display !== 'none';
            });

        if (trapTarget.__trapFocusHandler) {
            trapTarget.removeEventListener('keydown', trapTarget.__trapFocusHandler);
            delete trapTarget.__trapFocusHandler;
            delete trapTarget.dataset.trapFocusBound;
        }

        if (!trapTarget.dataset.trapFocusBound) {
            const handleKeydown = (event) => {
                if (event.key !== 'Tab') return;

                const current = getVisibleFocusables();
                if (!current.length) return;

                const first = current[0];
                const last = current[current.length - 1];
                const activeEl = document.activeElement;

                if (!trapTarget.contains(activeEl)) {
                    event.preventDefault();
                    (event.shiftKey ? last : first).focus();
                    return;
                }

                if (event.shiftKey) {
                    if (!trapTarget.contains(activeEl) || activeEl === first) {
                        event.preventDefault();
                        last.focus();
                    }
                } else {
                    if (activeEl === last) {
                        event.preventDefault();
                        first.focus();
                    }
                }
            };

            trapTarget.addEventListener('keydown', handleKeydown);
            trapTarget.dataset.trapFocusBound = 'true';
            trapTarget.__trapFocusHandler = handleKeydown;
        }
    }

    function getFocusableElements(container) {
        return Array.from(
            container.querySelectorAll(
                'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]):not([tabindex="-1"]), select:not([disabled]):not([tabindex="-1"]), textarea:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])'
            )
        ).filter((element) => {
            if (element.disabled) return false;
            if (element.closest('[aria-hidden="true"]')) return false;
            return element.tabIndex >= 0;
        });
    }




    function changeProductsCountToH2() {
        const subtitleCount = document.querySelector('.boost-sd__toolbar-item div.boost-sd__product-count');

        if (subtitleCount) {
            const h2 = document.createElement('h2');
            h2.innerText = subtitleCount.innerText;
            h2.className = subtitleCount.className;
            h2.style.letterSpacing = 'normal';
            h2.style.margin = '0';
            subtitleCount.replaceWith(h2);
            return true;
        }

        return false;
    }

    if (!changeProductsCountToH2()) {
        const observer = new MutationObserver(() => changeProductsCountToH2());

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    function initBoostAriaLabel() {
        const container = document.querySelector('.boost-sd__instant-search-container-mobile');

        if (!container) {
            setTimeout(initBoostAriaLabel, 500);
            return;
        }

        function setAriaLabel() {
            const input = container.querySelector('.boost-sd__search-widget-init-input');
            if (input && (!input.getAttribute('aria-label') || input.getAttribute('aria-label') === '')) {
                input.setAttribute('aria-label', 'Search');
            }
        }

        const observer = new MutationObserver(setAriaLabel);
        observer.observe(container, {
            childList: true,
            subtree: true
        });

        setAriaLabel();
    }

    initBoostAriaLabel();

    function fixTabListPrudct() {
        const container = document.querySelector('#shopify-section-pr_description');
        if (!container) return;

        const tablist = container.querySelector('[role="tablist"]');
        const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
        const panels = tabs.map(t => document.getElementById(t.getAttribute('aria-controls')));

        tabs.forEach(element => {
            const parent = element.parentElement;
            const isActive = parent.classList.contains('active');
            element.setAttribute('tabindex', isActive ? '0' : '-1');
            element.setAttribute('aria-selected', isActive);
        });

        function activateTab(tab) {
            tabs.forEach((t, i) => {
                const selected = t === tab;
                t.setAttribute('aria-selected', selected);
                t.tabIndex = selected ? 0 : -1;
                panels[i].hidden = !selected;
            });
            tab.focus();
        }

        tablist.addEventListener('click', (e) => {
            if (e.target.getAttribute('role') === 'tab') activateTab(e.target);
        });

        tablist.addEventListener('keydown', (e) => {
            const i = tabs.indexOf(document.activeElement);
            if (i === -1) return;

            let next = null;
            switch (e.key) {
                case 'ArrowRight': next = tabs[(i + 1) % tabs.length]; break;
                case 'ArrowLeft': next = tabs[(i - 1 + tabs.length) % tabs.length]; break;
                case 'Home': next = tabs[0]; break;
                case 'End': next = tabs[tabs.length - 1]; break;
                case 'Enter':
                case ' ': activateTab(tabs[i]); return;
                default: return;
            }
            e.preventDefault();
            next.focus();
        });

        tabs.forEach(t => t.addEventListener('keyup', e => {
            if (e.key === 'Enter') activateTab(e.currentTarget);
        }));
    }

    fixTabListPrudct();

    function waitForTMenu(callback) {
        const observer = new MutationObserver(function (mutations, obs) {
            const tmenuNav = document.querySelector('.tmenu_navbar.tmenu_initialized');
            if (tmenuNav && document.querySelectorAll('.tmenu_item--root').length > 0) {
                obs.disconnect();
                callback();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });
    }

    function addSubmenuHeadings() {
        document.querySelectorAll('.tmenu_item_level_1.tmenu_item_display_header').forEach((item, index) => {

            const link = item.querySelector('.tmenu_item_link');
            const textSpan = link ? link.querySelector('.tmenu_item_text') : null;
            const submenuList = item.querySelector('.tmenu_submenu_type_automatic');
            
            if (!link || !textSpan) return;

            const headingText = textSpan.textContent.trim();
            link.removeAttribute('role');
            const imgNoRequiredHeading = link.querySelector('img');
            if (link.parentElement.tagName !== 'H2' && !imgNoRequiredHeading) {
                const h2 = document.createElement('h2');
                h2.className = 'tmenu_submenu_heading';

                link.parentNode.insertBefore(h2, link);
                h2.appendChild(link);
            }

            if (submenuList && headingText) {
                submenuList.setAttribute('aria-label', headingText);
            }
        });
    }

    function addChevronKeyboardSupport() {

        document.querySelectorAll('.tmenu_item--root.tmenu_item_has_child').forEach(function (item) {
            const chevron = item.querySelector('.tmenu_indicator_icon');
            const link = item.querySelector('a.tmenu_item_link');

            if (!chevron || !link) return;

            chevron.setAttribute('tabindex', '0');
            chevron.setAttribute('role', 'button');

            const textSpan = link.querySelector('.tmenu_item_text');
            if (textSpan) {
                if (!textSpan.id) {
                    textSpan.id = 'menu-text-' + Math.random().toString(36).substr(2, 9);
                }
                chevron.setAttribute('aria-labelledby', textSpan.id);
            }

            const syncAriaExpanded = () => {
                link.removeAttribute('aria-expanded');
            };
            syncAriaExpanded();

            const observer = new MutationObserver(syncAriaExpanded);
            observer.observe(link, {
                attributes: true,
                attributeFilter: ['aria-expanded']
            });

            const observerParent = new MutationObserver(() => {
                const active = item.classList.contains('tmenu_item_active');
                chevron.setAttribute('aria-expanded', active.toString());
            });
            observerParent.observe(item, {
                attributes: true,
                attributeFilter: ['class']
            });


            chevron.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {

                    const hoverEvent = new MouseEvent('mouseenter', {
                        view: window,
                        bubbles: true,
                        cancelable: true
                    });

                    link.dispatchEvent(hoverEvent);
                    item.classList.toggle('tmenu_item_active');
                    // chevron.click();

                } else if (e.key === 'Escape') {
                    item.classList.remove('tmenu_item_active');
                    setTimeout(() => {
                        chevron.focus();
                    }, 300)
                }
            });
        });
    }

    function addAriaLabelToMainNav() {
        const mainNav = document.querySelector('.tmenu_navbar');
        if (mainNav && !mainNav.hasAttribute('aria-label')) {
            mainNav.setAttribute('aria-label', 'primary');
        }
    }

    waitForTMenu(function () {
        addSubmenuHeadings();
        addChevronKeyboardSupport();
        addAriaLabelToMainNav();
        const globalObserver = new MutationObserver(function () {
            addSubmenuHeadings();
            listenToMenuContainer();
        });

        globalObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    });

    function listenToMenuContainer() {
        const elements = document.querySelectorAll('.tmenu_item--root > .tmenu_submenu_type_mega, .tmenu_item--root > .tmenu_submenu_type_tab');
        elements.forEach((item) => {
            if (item.getAttribute('changed') === 'true') return;
            item.setAttribute('changed', 'true')
            const parent = item.closest('.tmenu_submenu');
            parent.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    const grandParent = parent.parentNode;
                    grandParent.classList.remove('tmenu_item_active');
                    const toggleIcon = grandParent.querySelector('.tmenu_indicator_icon');
                    toggleIcon.focus();
                }
            })
        })
    }

    function fixMenuIcons() {

        const update = (observer) => {
            const items = document.querySelectorAll('#nt_menu_id .tmenu_navbar .tmenu_item, #nt_menu_id .nt_mb_menu .tmenu_item');
            if (items.length === 0) return;

            items.forEach(li => {
                const link = li.querySelector('.tmenu_item_link');
                const arrow = link.querySelector('.tmenu_indicator');
                if (arrow) {
                    const icon = arrow.querySelector('.tmenu_indicator_icon');
                    icon.setAttribute('tabindex', '0');
                    icon.setAttribute('role', 'button');
                    const textSpan = li.querySelector('.tmenu_item_text');
                    if (textSpan) {
                        if (!textSpan.id) {
                            textSpan.id = 'menu-text-' + Math.random().toString(36).substr(2, 9);
                        }
                        icon.setAttribute('aria-labelledby', textSpan.id);
                    }

                    const newSpanContainer = document.createElement('span');
                    newSpanContainer.className = 'menu_link_arrow tmenu_item_link';
                    newSpanContainer.appendChild(link);
                    newSpanContainer.appendChild(arrow);
                    li.prepend(newSpanContainer)
                    arrow.addEventListener('keydown', (e) => {
                        if (e.key === 'Enter') arrow.click();
                    })
                }
            });
            if (observer) {
                observer.disconnect();
            }
        };

        update();

        const observer = new MutationObserver(() => {
            update(observer);
        });

        observer.observe(document.body, {
            subtree: true,
            childList: true
        });
    }

    fixMenuIcons();

    function fixProductImagesDisplay() {
        const productContainer = document.querySelector('.product');
        if (!productContainer) return;

        const reviewStars = productContainer.querySelector('.jdgm-prev-badge__stars');
        if (reviewStars) {
            const starsValue = reviewStars.getAttribute('data-score');
            reviewStars.setAttribute('aria-label', `${starsValue} out of 5 stars`);
        }

        hideInvisibleElements(productContainer);
        fixSpiceAddons(productContainer);

        document.querySelectorAll('[data-nametag="shop-portal-provider"]').forEach(data => {
            const section = data.shadowRoot.querySelector('section');
            if (section) {
                section.setAttribute('aria-label', 'Get it now, pay later');
                const title = section.querySelector('[data-testid="authorize-modal-header"] div');
                if (title) {
                    const h1 = document.createElement('h1');
                    copyAttributes(title, h1);
                    h1.textContent = title.textContent;
                    title.replaceWith(h1);
                }

                const button = section.querySelector('[data-testid="check-if-you-qualify-button"] button');
                if (button) {
                    button.addEventListener('focus', () => {
                        if (button.matches(':focus-visible')) {
                            button.style.outline = '1px solid #000';
                            button.style.outlineOffset = '6px';
                        }
                    });

                    button.addEventListener('blur', () => {
                        button.style.outline = '';
                        button.style.outlineOffset = '';
                    });
                }

                section.querySelectorAll('a').forEach(link => {
                    link.style.outlineOffset = '3px';
                    link.style.outlineColor = '#000';
                });

                const logo = section.querySelector('footer small svg');
                if (logo) {
                    logo.removeAttribute('aria-labelledby');
                    logo.setAttribute('aria-label', 'Affirm logo');
                }
            }
        })

        setTimeout(() => {
            const inputQty = productContainer.querySelector('.spice_select_variant_quantity');
            if (inputQty) {
                const label = inputQty.previousElementSibling;
                if (label.tagName === 'LABEL') {
                    label.setAttribute('for', inputQty.id);
                }
            }
        }, 1000);

        const observerReview = new MutationObserver(() => {
            const customerReviewsContainer = document.querySelector('#judgeme_product_reviews .jdgm-form-wrapper');

            if (!customerReviewsContainer) return;

            const titleWriteReview = customerReviewsContainer.querySelector('.jdgm-form__title');
            if (titleWriteReview) {
                const newTitle = document.createElement('h2');
                copyAttributes(titleWriteReview, newTitle);
                newTitle.innerText = titleWriteReview.innerText;
                titleWriteReview.replaceWith(newTitle);
            }

            customerReviewsContainer.querySelectorAll('.jdgm-form__fieldset label').forEach(label => {
                const p = document.createElement('p');
                p.innerText = label.innerText;
                p.style.marginBottom = '10px';
                label.replaceWith(p);
            });
            observerReview.disconnect();
        })

        observerReview.observe(document.body, {
            childList: true,
            subtree: true
        });

        productContainer.querySelectorAll('a').forEach(link => {
            if (link.getAttribute('title')) {
                link.removeAttribute('title');
            }
        });

        productContainer.querySelectorAll('.variations_button .compare_add, .variations_button .wis_added, .variations_button .wishlistadd').forEach(link => {
            link.removeAttribute('href');
            link.setAttribute('tabindex', '0');
            link.setAttribute('role', 'link');
            link.style.cursor = 'pointer';
        })

        const observer = new MutationObserver(() => {
            const btns = productContainer.querySelectorAll('.product-images .n-item');
            if (btns.length === 0) return;

            // Verify Flickity is fully initialized before processing
            const flickityViewport = productContainer.querySelector('.p-thumb .flickity-viewport');
            const flickitySlider = flickityViewport?.querySelector('.flickity-slider');

            // If Flickity exists but slider is empty, wait
            if (flickityViewport && (!flickitySlider || flickitySlider.children.length === 0)) {
                console.log('Flickity viewport found but empty, waiting...');
                return; // Keep observing
            }

            // Verify main images are ready before processing
            const mainImages = productContainer.querySelectorAll('.p-thumb .p-item');
            if (mainImages.length === 0) {
                console.log('Main images not ready yet, continuing to observe...');
                return; // Keep observing
            }

            // All checks passed, now process everything
            btns.forEach((btn, index) => {
                btn.setAttribute('role', 'button');
                btn.setAttribute('tabindex', '0');
                btn.setAttribute('image-index', index + 1);
                btn.setAttribute('aria-label', `View product image ${index + 1} of ${btns.length}`);
                setTimeout(() => {
                    btn.removeAttribute('aria-hidden');
                }, 1000);
            });

            const flickityButtons = productContainer.querySelectorAll('.product-images .flickity-button, .btn_pnav_prev, .btn_pnav_next');
            flickityButtons.forEach(btn => {
                btn.setAttribute('tabindex', '-1');
                btn.setAttribute('aria-hidden', 'true');
            });

            const navCarousel = productContainer.querySelector('.p-nav');
            ensureElementTabindexMinusOne(navCarousel);

            // Hide main images container from keyboard navigation (like Rustic Kitchen)
            const mainImagesContainer = productContainer.querySelector('.p-thumb');
            if (mainImagesContainer) {
                mainImagesContainer.removeAttribute('tabindex');
            }

            const totalImages = mainImages.length || btns.length;

            mainImages.forEach((img, index) => {
                if (totalImages > 0) {
                    img.setAttribute('aria-label', `Open image ${index + 1} of ${totalImages} in modal`);
                }
                img.setAttribute('tabindex', '0');
                img.setAttribute('role', 'button');
                img.addEventListener('click', () => fixImageViewModal(img));

                // Add keyboard support: Enter to open modal
                img.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        img.click();
                    }
                });
            });

            observer.disconnect();
        });

        observer.observe(productContainer, {
            childList: true,
            subtree: true
        });

        function fixImageViewModal(triggerElement) {
            setTimeout(() => {
                const modal = document.querySelector('.pswp');
                if (!modal) return;

                modal.querySelectorAll('.pswp__button--arrow--left, .pswp__button--arrow--right').forEach(element => {
                    element.setAttribute('tabindex', '-1');
                    element.setAttribute('aria-hidden', 'true');
                });

                const btnsModal = modal.querySelectorAll('.pswp .pswp__thumbnails .pswp_thumb_item');
                btnsModal.forEach((element, index) => {
                    element.setAttribute('role', 'button');
                    element.setAttribute('tabindex', '0');
                    element.setAttribute('image-index', index + 1);
                    element.setAttribute('aria-label', `View product image ${index + 1} of ${btnsModal.length}`);
                });

                modal.querySelectorAll('.pswp__button--close, .pswp__button--share, .pswp__button--fs, .pswp__button--zoom').forEach(element => {
                    element.setAttribute('aria-label', element.getAttribute('title'));
                });

                trapFocus(modal);
            }, 500);
        }

        function ensureElementTabindexMinusOne(element) {
            if (!element) return;

            const enforceTabindex = () => {
                if (element.getAttribute('tabindex')) {
                    element.removeAttribute('tabindex');
                }
            };

            enforceTabindex();

            if (!element.__tabindexObserver) {
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (mutation.attributeName === 'tabindex') {
                            enforceTabindex();
                        }
                    });
                });

                observer.observe(element, {
                    attributes: true,
                    attributeFilter: ['tabindex']
                });

                element.__tabindexObserver = observer;
            }
        }

        function hideInvisibleElements(container) {
            const paymentTerms = container.querySelector('shopify-payment-terms');
            if (paymentTerms) {
                const content = paymentTerms.shadowRoot.querySelector('#prequalAmountContainer');
                if (content) {
                    content.setAttribute('aria-hidden', 'true');
                    content.querySelectorAll('div, iframe, span, button').forEach(item => {
                        item.setAttribute('tabindex', '-1');
                        item.setAttribute('aria-hidden', 'true');
                    })
                }
            }
        }

        function fixSpiceAddons(container) {
            const fieldset = container.querySelector('#spiceaddonsappid');
            if (!fieldset) return;

            const newFieldset = document.createElement('fieldset');
            const newLegend = document.createElement('legend');
            copyAttributes(fieldset, newFieldset);

            const title = fieldset.querySelector('.sg-pro-access-heading');
            if (title) {
                copyAttributes(title, newLegend);
                newLegend.innerText = title.innerText;
                newLegend.id = 'fieldset_heading';
                title.replaceWith(newLegend);

                fieldset.querySelectorAll('.sg-checkbox-label').forEach(labelHidden => {
                    labelHidden.querySelector('.sg_sr-only').remove();
                    const divElement = document.createElement('div');
                    copyAttributes(labelHidden, divElement);
                    divElement.innerHTML = labelHidden.innerHTML;
                    fieldset.querySelector('.sg-pro-access-product-title-area').id = "title_access_product_id";
                    divElement.setAttribute('aria-describedby', 'title_access_product_id');
                    labelHidden.replaceWith(divElement);

                    newFieldset.innerHTML = fieldset.innerHTML;
                    newFieldset.setAttribute('aria-describedby', newLegend.id);
                    fieldset.replaceWith(newFieldset);
                });
            }



        }
    }

    fixProductImagesDisplay();

    function fixStructuralBreaks() {
        function apply(root = document) {
            if (root instanceof Element && root.matches('hr, br') && !root.hasAttribute('aria-hidden')) {
                root.setAttribute('aria-hidden', 'true');
            }

            if (typeof root.querySelectorAll === 'function') {
                root.querySelectorAll('hr:not([aria-hidden]), br:not([aria-hidden])').forEach(element => {
                    element.setAttribute('aria-hidden', 'true');
                });
            }
        }

        apply();

        const observer = new MutationObserver(mutations => {
            mutations.forEach(({ addedNodes }) => {
                addedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                        apply(node);
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    fixStructuralBreaks();

    function fixStrongSeparators() {
        if (!window.location.pathname.toLowerCase().includes('returns-refunds')) return;

        const separatorPattern = /^_+$/;
        const linkSelector = 'a[href*="/pages/service"]';
        const combinedSelector = `strong, ${linkSelector}`;

        function processElement(element) {
            if (element.matches('strong') && !element.hasAttribute('aria-hidden')) {
                const text = element.textContent ? element.textContent.replace(/\s/g, '') : '';
                if (text && separatorPattern.test(text)) {
                    element.setAttribute('aria-hidden', 'true');
                }
            }

            if (element.matches(linkSelector)) {
                element.style.textDecoration = 'underline';
            }
        }

        function apply(root = document) {
            if (root instanceof Element) {
                processElement(root);
            }

            if (typeof root.querySelectorAll === 'function') {
                root.querySelectorAll(combinedSelector).forEach(processElement);
            }
        }

        apply();

        const observer = new MutationObserver(mutations => {
            mutations.forEach(({ addedNodes }) => {
                addedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                        apply(node);
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    fixStrongSeparators();
    function hidePriceFilterPips() {
        if (!window.location.pathname.includes('/search') && !window.location.pathname.includes('/collections')) return;

        const selector = '#pf_p_price-toggle-target .noUi-pips.noUi-pips-horizontal';

        function mark(element) {
            if (!element || !element.classList) return;
            if (!element.classList.contains('noUi-pips') || !element.classList.contains('noUi-pips-horizontal')) return;
            if (!element.closest('#pf_p_price-toggle-target')) return;
            element.setAttribute('aria-hidden', 'true');
        }

        function apply(root = document) {
            if (root instanceof Element) {
                if (root.matches(selector)) {
                    mark(root);
                } else if (root.matches('.noUi-pips.noUi-pips-horizontal')) {
                    mark(root);
                }
            }

            if (typeof root.querySelectorAll === 'function') {
                root.querySelectorAll(selector).forEach(mark);
            }
        }

        apply();

        const observer = new MutationObserver(mutations => {
            mutations.forEach(({ addedNodes }) => {
                addedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                        apply(node);
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    hidePriceFilterPips();

    function labelPriceHandles() {
        if (!window.location.pathname.includes('/search') && !window.location.pathname.includes('/collections')) return;

        function apply(container = document) {
            if (!(container instanceof Element || container instanceof Document || container instanceof DocumentFragment)) {
                return;
            }

            function setLabel(selector, label) {
                const handle = container.querySelector(selector);
                if (handle) {
                    handle.setAttribute('aria-label', label);
                }
            }

            setLabel('.noUi-handle.noUi-handle-lower', 'Minimum Price');
            setLabel('.noUi-handle.noUi-handle-upper', 'Maximum Price');
        }

        apply();

        const observer = new MutationObserver(mutations => {
            mutations.forEach(({ addedNodes }) => {
                addedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                        apply(node);
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    labelPriceHandles();



    // enhanceViewToggleTooltips();

    function clearProductImageAlts() {
        if (!window.location.pathname.includes('/collections/')) return;

        const selector = '.boost-sd__product-image-img.boost-sd__product-image-img--main';

        function apply(root = document) {
            if (root instanceof Element && root.matches(selector)) {
                root.alt = '';
            }

            if (typeof root.querySelectorAll === 'function') {
                root.querySelectorAll(selector).forEach(img => {
                    img.alt = '';
                });
            }
        }

        apply();

        const observer = new MutationObserver(mutations => {
            mutations.forEach(({ addedNodes }) => {
                addedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                        apply(node);
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    clearProductImageAlts();

    function describeSoldOutBadges() {
        if (!window.location.pathname.includes('/collections/')) return;

        function apply() {
            const links = document.querySelectorAll('.boost-sd__product-link.boost-sd__product-image');

            links.forEach((link, index) => {
                const productItem = link.closest('.boost-sd__product-item, .boost-sd__product-item-list-view-layout');
                if (!productItem) return;

                const title = productItem.querySelector('.boost-sd__product-title');
                const label = productItem.querySelector('.boost-sd__product-label-text');
                const linkId = `product_title_${index}`;

                link.id = linkId;

                if (title) {
                    link.setAttribute('aria-label', title.textContent.trim());
                }

                if (label) {
                    const labelId = `extra_product_content_${index}`;
                    label.id = labelId;
                    link.setAttribute('aria-describedby', `extra_product_content_${index}`);
                } else {
                    link.removeAttribute('aria-describedby');
                }

                const quickViewBtn = productItem.querySelector('.boost-sd__button--quick-view');
                if (quickViewBtn) {
                    quickViewBtn.setAttribute('aria-describedby', linkId);
                }

                const addToCartBtn = productItem.querySelector('.boost-sd__button--primary, .boost-sd__button--select-option, .boost-sd__button--add-to-cart');
                if (addToCartBtn) {
                    addToCartBtn.setAttribute('aria-describedby', linkId);
                }
            });
        }

        apply();

        const observer = new MutationObserver(() => {
            apply();
            // observer.disconnect();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });
    }

    describeSoldOutBadges();

    function copyAttributes(source, target) {
        if (!source || !target) return;

        for (const attr of source.attributes) {
            target.setAttribute(attr.name, attr.value);
        }
    }


    function fixBlogImagesAltRest() {
        if (!window.location.pathname.includes('/blog')) return;

        const postContainer = document.querySelector('.dib-post-content');

        if (postContainer) {
            postContainer.querySelectorAll('img:not(.image-with-text)').forEach(img => {
                img.setAttribute('alt', '');
            });
        }

        const observer = new MutationObserver(() => {
            const postContainerIn = document.querySelector('.dib-post-content');
            if (!postContainerIn) return;

            postContainerIn.querySelectorAll('img:not(.image-with-text)').forEach(img => {
                img.setAttribute('alt', '');
            });

            observer.disconnect();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    fixBlogImagesAltRest();

    function fixAudioPlayerAriaLabel() {
        if (!window.location.pathname.includes('/blog/')) return;

        const observer = new MutationObserver(() => {
            const playPauseButton = document.querySelector('.dib-audio-play-pause');
            const audioElement = document.getElementById('dib-audio-element');

            if (!playPauseButton || !audioElement) return;

            playPauseButton.setAttribute('aria-label', 'Play');

            audioElement.addEventListener('play', () => {
                playPauseButton.setAttribute('aria-label', 'Pause');
            });

            audioElement.addEventListener('pause', () => {
                playPauseButton.setAttribute('aria-label', 'Play');
            });

            audioElement.addEventListener('ended', () => {
                playPauseButton.setAttribute('aria-label', 'Play');
            });

            observer.disconnect();
        });

        const audioContainer = document.getElementById('dib-audio');
        if (!audioContainer) return;

        observer.observe(audioContainer, {
            childList: true,
            subtree: true
        });
    }

    fixAudioPlayerAriaLabel();

    function fixAudioPlayerContainerAttributes() {
        if (!window.location.pathname.includes('/blog/')) return;

        const audioContainer = document.getElementById('dib-audio');
        if (!audioContainer) return;

        const applyAttributes = () => {
            audioContainer.setAttribute('role', 'region');
            audioContainer.setAttribute('aria-label', 'Listen to article');
            return true;
        };

        if (applyAttributes()) {
            return;
        }

        const observer = new MutationObserver(() => {
            if (applyAttributes()) {
                observer.disconnect();
            }
        });

        observer.observe(audioContainer, {
            childList: true,
            subtree: true
        });
    }

    fixAudioPlayerContainerAttributes();

    function fixAudioTimeToggleAriaLabel() {
        if (!window.location.pathname.includes('/blog/')) return;

        const postContainer = document.querySelector('.dib-post-single');

        if (postContainer) {
            postContainer.querySelectorAll('img:not(.image-with-text)').forEach(img => {
                img.setAttribute('alt', '');
            });
        }

        const applyFix = () => {
            const button = document.querySelector('.dib-audio-time-remaining');
            const audio = document.getElementById('dib-audio-element');

            if (!button || !audio) {
                return false;
            }

            if (button.dataset.timeLabelEnhanced === 'true') {
                return true;
            }

            button.dataset.timeLabelEnhanced = 'true';

            let showingRemaining = true;

            const updateLabel = () => {
                const timeValue = (button.textContent || '').trim();

                const label = showingRemaining
                    ? `Time remaining ${timeValue}. Click to switch to elapsed time.`
                    : `Time elapsed ${timeValue}. Click to switch to time remaining.`;

                button.setAttribute('aria-label', label);
            };

            updateLabel();

            audio.addEventListener('timeupdate', updateLabel);
            audio.addEventListener('loadedmetadata', updateLabel);

            button.addEventListener('click', () => {
                showingRemaining = !showingRemaining;
                updateLabel();
            });

            return true;
        };

        if (applyFix()) {
            return;
        }

        const audioContainer = document.getElementById('dib-audio');
        if (!audioContainer) return;

        const observer = new MutationObserver(() => {
            if (applyFix()) {
                observer.disconnect();
            }
        });

        observer.observe(audioContainer, {
            childList: true,
            subtree: true
        });
    }

    fixAudioTimeToggleAriaLabel();

    function fixAudioSpeedAriaLabel() {
        if (!window.location.pathname.includes('/blog/')) return;

        const observer = new MutationObserver(() => {
            const speedButton = document.querySelector('.dib-audio-speed');

            if (!speedButton) return;

            const currentSpeed = speedButton.textContent;
            speedButton.setAttribute('aria-label', `Audio Speed: ${currentSpeed}`);

            const textObserver = new MutationObserver(() => {
                const speed = speedButton.textContent;
                speedButton.setAttribute('aria-label', `Audio Speed: ${speed}`);
            });

            textObserver.observe(speedButton, {
                childList: true,
                characterData: true,
                subtree: true
            });

            observer.disconnect();
        });

        const audioContainer = document.getElementById('dib-audio');
        if (!audioContainer) return;

        observer.observe(audioContainer, {
            childList: true,
            subtree: true
        });
    }

    fixAudioSpeedAriaLabel();

    function fixAudioDisclaimerNotice() {
        if (!window.location.pathname.includes('/blog/')) return;

        const applyAttributes = () => {
            const infoLink = document.querySelector('.dib-audio-disclaimer svg');
            if (!infoLink) return false;
            infoLink.setAttribute('role', 'button');
            infoLink.setAttribute('tabindex', '0');
            infoLink.setAttribute('aria-label', 'Show Audio information');

            const parent = infoLink.parentNode;
            const span = parent.querySelector('span');
            span.setAttribute('aria-hidden', 'true');
            const link = parent.querySelector('a');
            link.tabIndex = '-1';
            const invisibleAlert = document.querySelector('#invisible-alert');

            const toggle = (infoLink) => {
                parent.classList.toggle('toggle-infor-audio');
                if (parent.classList.contains('toggle-infor-audio')) {
                    span.setAttribute('aria-hidden', 'false')
                    link.removeAttribute('tabindex');
                    invisibleAlert.removeAttribute('aria-hidden');
                    setTimeout(() => {
                        invisibleAlert.innerText = span.innerText;
                    }, 300)
                    infoLink.setAttribute('aria-label', 'Hide Audio information');
                } else {
                    span.setAttribute('aria-hidden', 'true')
                    link.setAttribute('tabindex', '-1');
                    infoLink.setAttribute('aria-label', 'Show Audio information');
                    invisibleAlert.innerText = '';
                    invisibleAlert.setAttribute('aria-hidden', 'true');
                }
            };

            infoLink.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === 'Escape') toggle(infoLink);
            });

            infoLink.addEventListener('click', () => toggle(infoLink));

            return true;
        };

        if (applyAttributes()) {
            return;
        }

        const audioContainer = document.getElementById('dib-audio');
        if (!audioContainer) return;

        const observer = new MutationObserver(() => {
            if (applyAttributes()) {
                observer.disconnect();
            }
        });

        observer.observe(audioContainer, {
            childList: true,
            subtree: true
        });
    }

    fixAudioDisclaimerNotice();

    function enableAudioProgressKeyboard() {
        if (!window.location.pathname.includes('/blog/')) return;

        const container = document.querySelector('.dib-audio-progress-container');
        if (!container) return;

        const applyEnhancements = () => {
            const dragHandle = container ? container.querySelector('.dib-audio-drag-handle') : null;
            const audio = document.getElementById('dib-audio-element');

            if (!container || !dragHandle || !audio) {
                return false;
            }

            if (dragHandle.dataset.keyboardEnhanced === 'true') {
                return true;
            }

            dragHandle.dataset.keyboardEnhanced = 'true';
            dragHandle.setAttribute('tabindex', '0');
            dragHandle.setAttribute('role', 'slider');
            dragHandle.setAttribute('aria-label', 'Audio Progress');
            dragHandle.setAttribute('aria-valuemin', '0');

            const getStep = () => {
                const duration = isFinite(audio.duration) && audio.duration > 0 ? audio.duration : 0;
                return duration > 0 ? Math.max(duration / 100, 1) : 5;
            };

            const clampTime = (time) => {
                if (isFinite(audio.duration) && audio.duration > 0) {
                    return Math.min(Math.max(time, 0), audio.duration);
                }
                return Math.max(time, 0);
            };

            const formatSeconds = (seconds) => {
                if (!isFinite(seconds) || seconds <= 0) return '0:00';
                const mins = Math.floor(seconds / 60);
                const secs = Math.floor(seconds % 60);
                return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
            };

            const updateSliderAria = () => {
                const timeButton = document.querySelector('.dib-audio-time-remaining');
                const timeText = timeButton && timeButton.textContent
                    ? timeButton.textContent.trim()
                    : '0:00';

                // dragHandle.setAttribute('aria-valuenow', timeText);
                dragHandle.setAttribute('aria-valuetext', timeText);
                if (audio.duration && isFinite(audio.duration)) {
                    // dragHandle.setAttribute('aria-valuemax', formatSeconds(audio.duration));
                }
            };

            updateSliderAria();

            audio.addEventListener('timeupdate', updateSliderAria);
            audio.addEventListener('loadedmetadata', updateSliderAria);

            dragHandle.addEventListener('keydown', (event) => {
                const step = getStep();
                let handled = false;

                if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
                    audio.currentTime = clampTime(audio.currentTime + step);
                    handled = true;
                } else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
                    audio.currentTime = clampTime(audio.currentTime - step);
                    handled = true;
                }

                if (handled) {
                    updateSliderAria();
                    event.preventDefault();
                    event.stopPropagation();
                }
            });

            return true;
        };

        if (applyEnhancements()) {
            return;
        }

        const observer = new MutationObserver(() => {
            if (applyEnhancements()) {
                observer.disconnect();
            }
        });

        observer.observe(container, {
            childList: true,
            subtree: true
        });
    }

    enableAudioProgressKeyboard();

    function fixRelatedArticlesList() {
        if (!window.location.pathname.includes('/blog/')) return;

        const applyFix = () => {
            const containers = document.querySelectorAll('.dib-related-posts');
            if (!containers.length) {
                return false;
            }

            containers.forEach((container) => {
                container.setAttribute('role', 'list');

                const applyItemsRole = () => {
                    const items = container.querySelectorAll('.dib-related-post');
                    items.forEach((item) => {
                        if (!item.hasAttribute('role')) {
                            item.setAttribute('role', 'listitem');
                        }

                        const title = item.querySelector('h2');
                        if (title) {
                            const heading = document.createElement('div');
                            heading.className = title.className;
                            heading.innerHTML = title.innerHTML;
                            title.replaceWith(heading);
                        }

                        const imageLink = item.querySelector('.dib-post-featured-image a');
                        const titleLink = item.querySelector('.dib-post-title-link');
                        if (imageLink && titleLink) {
                            const newlink = replaceLinkWithSpan(imageLink, titleLink);
                            newlink.querySelector('img').setAttribute('alt', '');
                        }
                    });
                };

                applyItemsRole();
            });

            return true;
        };

        if (applyFix()) {
            return;
        }

        const container = document.querySelector('.dib-related-posts');
        if (!container) return;

        const observer = new MutationObserver(() => {
            if (applyFix()) {
                observer.disconnect();
            }
        });

        observer.observe(container, {
            childList: true,
            subtree: true
        });
    }

    fixRelatedArticlesList();

    function fixSocialSharingAccessibility() {
        if (!window.location.pathname.includes('/blog/')) return;

        const sharingContainer = document.querySelector('.dib-sharing');
        if (!sharingContainer) return;

        sharingContainer.setAttribute('role', 'list');
        sharingContainer.setAttribute('aria-label', 'Share on social media');

        const shareLinks = sharingContainer.querySelectorAll('.dib-share-link');
        shareLinks.forEach(link => {
            if (link.parentElement.getAttribute('role') === 'listitem') return;

            const listItem = document.createElement('div');
            listItem.setAttribute('role', 'listitem');
            listItem.style.display = 'inline-block';

            link.parentNode.insertBefore(listItem, link);
            listItem.appendChild(link);
        });
    }

    fixSocialSharingAccessibility();

    function listSemanticsToCategories() {
        if (!window.location.pathname.includes('/blog/')) return;

        const listText = document.querySelector('.dib-no-author .dib-post-category-text');
        if (!listText) return;

        const parent = listText.parentNode;
        parent.setAttribute('role', 'presentation');

        const container = document.createElement('span');
        container.className = listText.className;
        container.setAttribute('aria-label', 'Categories');
        container.setAttribute('role', 'list');
        container.style.display = 'flex';
        container.style.gap = '5px';
        container.style.marginBottom = '-20px';

        // Move & wrap children
        const wrapLink = (a) => {
            const w = document.createElement('span');
            w.setAttribute('role', 'listitem')
            w.appendChild(a);
            container.appendChild(w);
        };
        const addSeparator = (text) => {
            const w = document.createElement('span');
            w.textContent = text;
            w.setAttribute('aria-hidden', 'true');
            w.setAttribute('role', 'presentation');
            container.appendChild(w);
        };

        // Iterate original nodes
        Array.from(listText.childNodes).forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'A') {
                wrapLink(node);
            } else {
                const t = (node.textContent || '').trim();
                if (t) addSeparator(t);
            }
        });

        listText.replaceWith(container);

    }
    listSemanticsToCategories();


    function fixSocialMediaRolesBlog() {
        if (!window.location.pathname.includes('/blog/')) return;

        document.querySelectorAll('.social-media-links').forEach(wrapper => {
            wrapper.setAttribute('role', 'list');
            const items = wrapper.querySelectorAll('p');
            items.forEach(item => {
                item.setAttribute('role', 'listitem');
            });
        });

        document.querySelectorAll('.list').forEach(wrapper => {
            wrapper.setAttribute('role', 'list');
            const items = wrapper.querySelectorAll('.child-item');
            items.forEach(item => {
                item.setAttribute('role', 'listitem');
            });
        });
    }

    fixSocialMediaRolesBlog();

    function fixSocialSharingAccessibility() {
        if (!window.location.pathname.includes('/blog/')) return;

        const sharingContainer = document.querySelector('.dib-sharing.dib-sharing-top');
        if (!sharingContainer) return;

        sharingContainer.setAttribute('role', 'list');
        sharingContainer.setAttribute('aria-label', 'Social media');

        const shareLinks = sharingContainer.querySelectorAll('.dib-share-link');
        shareLinks.forEach(link => {
            if (link.parentElement.getAttribute('role') === 'listitem') return;

            const listItem = document.createElement('div');
            listItem.setAttribute('role', 'listitem');
            listItem.style.display = 'inline-block';

            link.parentNode.insertBefore(listItem, link);
            listItem.appendChild(link);
        });
    }

    fixSocialSharingAccessibility();

    function fixDesignConsultation() {
        if (!window.location.pathname.includes('/design-consultations')) return;

        const items = document.querySelectorAll('.cat_space_item');

        let ids = '';
        items.forEach((element, index) => {
            const links = element.querySelectorAll('a');
            if (links.length > 1 && index !== items.length - 1) {
                replaceLinkWithSpan(links[1], links[links.length - 1], true, true);
            }
            if (links.length > 1) {
                const link = links[0]
                replaceLinkWithSpan(link, links[links.length - 1], true, false);
                link.setAttribute('tabindex', '-1');
                link.setAttribute('role', 'img');
                if (link) {
                    ids += link.id + ' ';
                }

            }

            if (index === items.length - 1) {
                links[links.length - 1].setAttribute('aria-describedby', ids);
            }

        });
    }

    fixDesignConsultation();

    function replaceLinkWithSpan(link, secondLink, hasAttrLink, isSecondLinkHidden) {
        let newLink = link;

        if (hasAttrLink) {
            newLink.setAttribute('role', 'link');
            newLink.setAttribute('tabindex', isSecondLinkHidden ? '-1' : '0');
            if (isSecondLinkHidden) {
                newLink.setAttribute('aria-hidden', 'true');
            }
        } else {
            newLink = document.createElement('span');
            copyAttributes(link, newLink);
            newLink.innerHTML = link.innerHTML;
            link.replaceWith(newLink);
        }

        newLink.removeAttribute('href');
        newLink.removeAttribute('target');
        newLink.style.cursor = 'pointer';

        newLink.addEventListener('click', () => {
            secondLink.click();
        });

        newLink.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                secondLink.click();
            }
        });
        return newLink;
    }

    function fixMobileMenuAccessibility() {
        const mobileMenuBtn = document.querySelector('[data-id="#nt_menu_canvas"]');
        const mobileMenuCanvas = document.getElementById('nt_menu_canvas');

        if (!mobileMenuCanvas) {
            setTimeout(fixMobileMenuAccessibility, 500);
            return;
        }

        let hasProcessed = false;

        function applyAccessibilityAttributes() {
            if (hasProcessed) return;

            const lists = mobileMenuCanvas.querySelectorAll('ul.tmenu_app_mobile');
            if (lists.length === 0) return;

            const iconX = mobileMenuCanvas.nextElementSibling;
            if (iconX && iconX.classList.contains('close_pp')) {
                const clone = iconX.cloneNode(true);
                clone.setAttribute('role', 'button');
                clone.setAttribute('aria-label', 'Close');
                clone.setAttribute('tabindex', '0');
                iconX.style.display = 'none';
                clone.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter') {
                        iconX.click();
                    }
                })

                clone.addEventListener('click', () => iconX.click())

                const headerMenu = mobileMenuCanvas.querySelector('.mb_nav_tabs');
                if (headerMenu) {
                    headerMenu.appendChild(clone);
                }
            }

            hasProcessed = true;

            lists.forEach(list => {
                if (!list.hasAttribute('role')) {
                    list.setAttribute('role', 'list');
                }
                list.querySelectorAll('li').forEach(li => {
                    if (!li.hasAttribute('role')) {
                        li.setAttribute('role', 'listitem');
                    }
                });
            });

            const accordionItems = mobileMenuCanvas.querySelectorAll('.tmenu_item .tmenu_item_link');
            
            accordionItems.forEach(item => {
                if (!item.hasAttribute('aria-expanded')) {
                    const parentLi = item.parentElement;
                    const indicator = item.querySelector('.tmenu_indicator')
                    if (indicator) {
                        indicator.setAttribute('aria-hidden', 'true');
                    }

                    item.addEventListener('click', () => {
                        setTimeout(() => {
                            const itemsContainer = item.nextElementSibling;
                            if (itemsContainer) {
                                itemsContainer.querySelectorAll('.tmenu_item').forEach(subItem => {

                                    const link = subItem.querySelector('.tmenu_item_link');

                                    if (link.getAttribute('href') !== 'javascript:;') {

                                        const arrow = link.querySelector('.tmenu_indicator');
                                        link.removeAttribute('role');
                                        if (arrow) {
                                            const icon = arrow.querySelector('.tmenu_indicator_icon');
                                            icon.setAttribute('tabindex', '0');
                                            icon.setAttribute('role', 'button');
                                            const textSpan = subItem.querySelector('.tmenu_item_text');
                                            if (textSpan) {
                                                if (!textSpan.id) {
                                                    textSpan.id = 'menu-text-' + Math.random().toString(36).substr(2, 9);
                                                }
                                                icon.setAttribute('aria-labelledby', textSpan.id);
                                            }

                                            const newSpanContainer = document.createElement('span');
                                            newSpanContainer.className = 'menu_link_arrow tmenu_item_link';
                                            newSpanContainer.appendChild(link);
                                            newSpanContainer.appendChild(arrow);
                                            subItem.prepend(newSpanContainer)
                                            arrow.addEventListener('keydown', (e) => {
                                                if (e.key === 'Enter') arrow.click();
                                            });
                                            liObserver(subItem, icon);
                                        }
                                    } else {

                                        const indicator = subItem.querySelector('.tmenu_indicator')
                                        if (indicator) {
                                            indicator.setAttribute('aria-hidden', 'true');
                                        }

                                        liObserver(subItem, link);
                                    }


                                })
                            }
                        }, 500);
                    })

                    liObserver(parentLi, item);
                }
            });
        }

        const contentObserver = new MutationObserver(function () {
            applyAccessibilityAttributes();
            if (hasProcessed) {
                contentObserver.disconnect();
            }
        });

        contentObserver.observe(mobileMenuCanvas, {
            childList: true,
            subtree: true
        });

        function liObserver(li, link) {
            link.setAttribute('aria-expanded', li.classList.contains('tmenu_item_active').toString());
            const liObserver = new MutationObserver(() => {
                const expanded = li.classList.contains('tmenu_item_active');

                if (link.getAttribute('aria-expanded') !== expanded) {
                    link.setAttribute('aria-expanded', expanded);
                }
            });

            liObserver.observe(li, {
                attributes: true,
                attributeFilter: ['class']
            });
        }

        applyAccessibilityAttributes();

        if (mobileMenuBtn) {
            const btnObserver = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.attributeName === 'class') {
                        const isOpen = mobileMenuCanvas.classList.contains('act_opened');
                        mobileMenuBtn.setAttribute('aria-expanded', isOpen.toString());
                    }
                });
            });

            btnObserver.observe(mobileMenuCanvas, {
                attributes: true,
                attributeFilter: ['class']
            });

            const initiallyOpen = mobileMenuCanvas.classList.contains('act_opened');
            mobileMenuBtn.setAttribute('aria-expanded', initiallyOpen.toString());
        }
    }

    fixMobileMenuAccessibility();

    function fixWishList() {
        const isWishView = location.search.includes('view=wish');
        if (!isWishView) return;

        const h1 = document.querySelector('#nt_content h1');

        if (!h1) {
            const texts = document.querySelectorAll('#nt_content .container p');
            if (texts.length > 1) {
                const newH1 = document.createElement('h1');
                newH1.innerText = texts[1].innerText;
                newH1.style.fontSize = '14px';
                newH1.style.color = '#fff';
                texts[1].replaceWith(newH1);
            }
        }
        
        document.querySelectorAll('.dev_view_cat').forEach((containerBtns) => {
            containerBtns.querySelectorAll('a').forEach((btn, index) => {
                setTimeout(() => {
                    if (index === 0) {
                    //Force first state
                    btn.click();
                    btn.setAttribute('aria-pressed', 'true');
                }

                btn.addEventListener('click', () => {
                    containerBtns.querySelectorAll('a').forEach(element => {
                        setTimeout(() => {
                            element.setAttribute('aria-pressed', element.classList.contains('active') ? 'true' : 'false');
                        }, 300);
                    });
                });
                }, 500);
            });
        });
    }

    function fixFaqAccessibility() {
        const faqSection = document.querySelector('.js_faq_ad');
        if (!faqSection) return;

        const accordionContainer = faqSection.querySelector('.shopify-tabs.sp-tabs');
        if (accordionContainer && !accordionContainer.hasAttribute('role')) {
            accordionContainer.setAttribute('role', 'list');
        }

        const faqItems = faqSection.querySelectorAll('.sp-tab');
        faqItems.forEach(item => {
            if (!item.hasAttribute('role')) {
                item.setAttribute('role', 'listitem');
            }

            const isActive = item.classList.contains('active');

            const trigger = item.querySelector('.tab-heading');
            trigger.setAttribute('role', 'button');
            trigger.setAttribute('aria-expanded', isActive.toString());
            trigger.addEventListener('click', function () {
                setTimeout(() => {
                    faqItems.forEach(faqItem => {
                        const isItemActive = faqItem.classList.contains('active');
                        faqItem.querySelector('.tab-heading').setAttribute('aria-expanded', isItemActive.toString());
                    });
                }, 50);
            });
        });

        const faqObserver = new MutationObserver(function () {
            fixFaqAccessibility();
        });

        faqObserver.observe(faqSection, {
            childList: true,
            subtree: true
        });
    }

    fixFaqAccessibility();

    fixWishList();

    function fixRebuyBundle() {
        const observer = new MutationObserver(() => {
            const container = document.querySelector('.rebuy-bundle');
            if (!container) return;

            container.querySelectorAll('.rebuy-product-info').forEach(element => {
                const imageLink = element.querySelector('.rebuy-bundle__image-item');
                const titleLink = element.querySelector('.rebuy-product-title');
                if (imageLink && titleLink) {
                    const newLink = replaceLinkWithSpan(imageLink, titleLink);
                    newLink.setAttribute('aria-hidden', 'true');
                }

                fixPrices(element);
                const starsContainer = element.querySelector('.rebuy-product-review');
                if (starsContainer) {
                    const fill = starsContainer.querySelector('.rebuy-star-rating-foreground');
                    const width = parseFloat(fill.style.width);
                    const stars = (width / 100) * 5;
                    const span = document.createElement('span');
                    span.innerText = `${stars.toFixed(1)} of 5 stars`;
                    span.classList.add('visually-hidden');
                    starsContainer.prepend(span)
                }
                element.querySelectorAll('img').forEach(img => img.setAttribute('alt', ''));
            });

            const parent = container.closest('.rebuy-widget');
            if (parent) {
                parent.querySelectorAll('.rebuy-bundle__actions').forEach(element => {
                    fixPrices(element);
                });

                const title = parent.querySelector('.primary-title');
                title.id = 'FBT_id';

                parent.querySelectorAll('.rebuy-button').forEach(btn => {
                    btn.setAttribute('aria-describedby', title.id);
                });

                parent.setAttribute('role', 'group');
                parent.setAttribute('aria-labelledby', title.id);
            }

            observer.disconnect();
        });

        function fixPrices(element) {
            const sale = element.querySelector('.rebuy-money.sale');
            const compare = element.querySelector('.rebuy-money.compare-at');
            if (sale && compare) {
                const currentlyText = document.createElement('span');
                const formerlyText = document.createElement('span');
                currentlyText.innerText = 'Currently';
                formerlyText.innerText = 'Formally';
                currentlyText.classList.add('visually-hidden');
                formerlyText.classList.add('visually-hidden');
                sale.prepend(currentlyText);
                compare.prepend(formerlyText);
            }
        }

        observer.observe(document.body, {
            subtree: true,
            childList: true
        });

    }

    fixRebuyBundle();

    function fixRelatedProducts(containerClass, isList) {

        const observer = new MutationObserver(() => {
            const container = document.querySelector(containerClass + ' .products');
            if (!container) return;
            container.removeAttribute('tabindex');

            const parent = container.closest('.product-extra');
            if (parent) {
                const emptySibling = parent.nextElementSibling;
                if (emptySibling && emptySibling.tagName === 'DIV' && emptySibling.getAttribute('style')) {
                    emptySibling.setAttribute('aria-hidden', 'true');
                }
            }

            const updateItem = (element) => {
                if (!element.classList.contains('is-selected')) {
                    element.querySelectorAll('a, button, [tabindex="0"]').forEach(focusableElement => {
                        focusableElement.setAttribute('tabindex', '-1');
                        focusableElement.setAttribute('aria-hidden', 'true');
                    });
                }

                const review = element.querySelector('.jdgm-prev-badge__stars');
                if (review) {
                    review.removeAttribute('tabindex');
                    const value = review.getAttribute('data-score');
                    review.removeAttribute('role');
                    review.removeAttribute('aria-label');
                    const label = `${value} out of 5 stars`;
                    const hidden = review.querySelectorAll('.visually-hidden');
                    hidden.forEach((el, i) => i === 0 ? el.textContent = label : el.remove());
                    if (!hidden.length) {
                        const span = document.createElement('span');
                        span.classList.add('visually-hidden');
                        span.innerText = label;
                        review.prepend(span);
                    }
                }

                const productTitleH3 = element.querySelector('h3');
                if (productTitleH3) {
                    const title = document.createElement('span');
                    copyAttributes(productTitleH3, title);
                    title.innerHTML = productTitleH3.innerHTML;
                    productTitleH3.replaceWith(title);
                }

                const prices = element.querySelectorAll('del, ins');
                if (prices.length > 1) {
                    const oldPriceValue = prices[0];
                    const newPriceValue = prices[1];
                    const newPrice = document.createElement('span');
                    newPrice.classList.add('visually-hidden');
                    newPrice.innerText = 'Formally';
                    oldPriceValue.prepend(newPrice);
                    const oldPrice = document.createElement('span');
                    oldPrice.classList.add('visually-hidden');
                    oldPrice.innerText = 'Currently';
                    newPriceValue.prepend(oldPrice);

                    const newPriceSpan = document.createElement('span');
                    const oldPriceSpan = document.createElement('span');

                    copyAttributes(oldPriceValue, newPriceSpan);
                    copyAttributes(newPriceValue, oldPriceSpan);

                    oldPriceSpan.innerHTML = oldPriceValue.innerHTML;
                    newPriceSpan.innerHTML = newPriceValue.innerHTML;
                    newPriceSpan.classList.add('off');
                    oldPriceSpan.classList.add('old');

                    oldPriceValue.replaceWith(oldPriceSpan);
                    newPriceValue.replaceWith(newPriceSpan);
                }
            };
            const products = container.querySelectorAll('.flickity-slider .product');

            if (isList) {
                const list = container.querySelector('.flickity-slider');
                list.setAttribute('role', 'region');
            }

            products.forEach((element, index) => {

                const imageObserver = new MutationObserver(() => {
                    const links = element.querySelectorAll('a, button, [tabindex="0"]');
                    if (!links.length > 3) return;

                    if (isList && element.classList.contains('is-selected')) {
                        element.setAttribute('aria-label', `Slide ${index+1} of ${products.length}`);
                        element.setAttribute('role', `group`);
                    }

                    updateItem(element);
                    const imageLink = element.querySelector('a.db');
                    const titleLink = element.querySelector('.product-info a.cd');
                    const jdgmWidget = element.querySelector('.jdgm-widget');

                    if (!titleLink || !jdgmWidget) {
                        imageObserver.disconnect();
                        return;
                    }

                    const reviewId = jdgmWidget.getAttribute('data-id');
                    titleLink.id = `title_related_${reviewId}`;

                    // const extraInformationContainerIn = element.querySelector('.nt_labels');
                    // if (extraInformationContainerIn) {
                    //     extraInformationContainerIn.id = `extra_info_${reviewId}`;
                    //     const describedBy = titleLink.getAttribute('aria-describedby');
                    //     titleLink.setAttribute('aria-describedby', describedBy ? `${describedBy} ${extraInformationContainerIn.id}` : extraInformationContainerIn.id);
                    // }

                    if (imageLink && titleLink) {
                        replaceLinkWithSpan(imageLink, titleLink);
                    }

                    element.querySelectorAll('.hover_button .compare_add, .hover_button .wis_added, .hover_button .wishlistadd, .pr_atc, .nt_add_qv').forEach(link => {
                        //We remove href from links that don't require the HREF
                        if (!link.classList.contains('nt_add_qv') && !link.classList.contains('pr_atc')) {
                            link.removeAttribute('href');
                        }
                        //Trick to remove redundant link
                        if (link.classList.contains('nt_add_qv')) {
                            link.setAttribute('href', link.getAttribute('href') + '/')
                        }

                        link.setAttribute('tabindex', '0');
                        link.setAttribute('role', 'button');
                        link.style.cursor = 'pointer';
                        link.setAttribute('aria-describedby', titleLink.id);
                    });


                    element.querySelectorAll('.hover_button div a, a.js_addtc').forEach(link => {
                        link.removeAttribute('href');
                        link.setAttribute('tabindex', '0');
                        link.style.cursor = 'pointer';
                    });

                    element.querySelectorAll('img').forEach(img => img.setAttribute('alt', ''));

                    if (!element.classList.contains('is-selected')) {
                        element.querySelectorAll('a, button, [tabindex="0"]').forEach(focusableElement => {
                            focusableElement.setAttribute('tabindex', '-1');
                            focusableElement.setAttribute('aria-hidden', 'true');
                        })
                    }

                    // const review = element.querySelector('.jdgm-prev-badge__stars');
                    // if (review) {
                    //     if (!review.querySelector('visually-hidden')) return;
                    //     review.removeAttribute('tabindex');
                    //     const value = review.getAttribute('data-score');
                    //     review.removeAttribute('role');
                    //     review.removeAttribute('aria-label');
                    //     const span = document.createElement('span');
                    //     span.classList.add('visually-hidden');
                    //     span.innerText = `${value} out of 5 stars`;
                    //     review.prepend(span);
                    // }

                    element.querySelectorAll('.hover_button a, .pr_atc').forEach(link => {
                        link.setAttribute('aria-describedby', titleLink.id);
                    });

                    imageObserver.disconnect();
                })

                imageObserver.observe(element, {
                    subtree: true,
                    childList: true
                });
            });

            observer.disconnect();


            document.querySelectorAll(containerClass + ' .flickity-button').forEach(btn => {
                const updateItemsStatus = () => {
                    setTimeout(() => {
                        container.querySelectorAll('.flickity-slider .product').forEach(element => {
                            const isActive = element.classList.contains('is-selected');
                            element.querySelectorAll('a, button, [tabindex="0"]').forEach(focusableElement => {
                                focusableElement.setAttribute('tabindex', isActive ? '0' : '-1');
                                focusableElement.setAttribute('aria-hidden', isActive ? 'true' : 'false');
                            })
                        });
                    }, 1000);
                }
                btn.addEventListener('click', updateItemsStatus);
                btn.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter') {
                        updateItemsStatus();
                    }
                });
            });
        });

        observer.observe(document.body, {
            subtree: true,
            childList: true
        });

    }

    fixRelatedProducts('.related.product-extra', true);

    function bestSellingAppliances() {

        const updateSlide = (tab) => {
            const listNames = tab.querySelectorAll('.product-title');

            if (listNames.length === 0) return false;

            setTimeout(() => {
                const productsContainer = tab.querySelector('.products');
                if (productsContainer) {
                    productsContainer.removeAttribute('tabindex');
                }
            }, 500);
            listNames.forEach((productTitleH3, index) => {
                const title = document.createElement('span');
                copyAttributes(productTitleH3, title);
                title.innerHTML = productTitleH3.innerHTML;
                productTitleH3.replaceWith(title);
                const product = title.closest('.product');
                if (product) {
                    product.setAttribute('role', 'group');
                    product.setAttribute('aria-label', `Slide ${index + 1} of ${listNames.length}`);
                }
            });

            return true;
        }

        const panels = document.querySelectorAll('.tab_se_wrap .tab_se_element');

        panels.forEach(tab => {
            const applied = updateSlide(tab);
            if (!applied) return;

            const nameObserver = new MutationObserver(() => {
                if (updateSlide(tab)) {
                    nameObserver.disconnect();
                }
            });

            nameObserver.observe(tab, {
                subtree: true,
                childList: true,
            });
        });

        panels.forEach(tab => {
            tab.setAttribute('aria-hidden', 'false');
            tab.querySelectorAll('a, button').forEach(element => {
                element.removeAttribute('ally-changed');
                element.removeAttribute('tabindex');
                element.removeAttribute('aria-hidden');
            });

            tab.querySelectorAll('.product-inner').forEach((productContainer, index) => {
                const titleLink = productContainer.querySelector('.product-title a');
                if (!titleLink) {
                    return;
                }
                const product = titleLink.closest('.product');
                if (!product) {
                    return;
                }
                const productsContainer = tab.querySelector('.products');
                if (productsContainer && !productsContainer.contains(product)) {
                    return;
                }
                // titleLink.id = `best_title_appliances_${index}`;

                productContainer.querySelectorAll('.jdgm-preview-badge, .price').forEach((element, indexIn) => {
                    if (element.classList.contains('jdgm-preview-badge')) {
                        const prices = element.querySelectorAll('del, ins');
                        if (prices.length > 1) {
                            const newPrice = document.createElement('span');
                            newPrice.classList.add('visually-hidden');
                            newPrice.innerText = 'Currently';
                            prices[0].prepend(newPrice);
                            const oldPrice = document.createElement('span');
                            oldPrice.classList.add('visually-hidden');
                            oldPrice.innerText = 'Formally';
                            prices[1].prepend(oldPrice);

                        }
                    }
                    // element.id = `detail_best_${indexIn}_${titleLink.id}`;
                    // const describedBy = titleLink.getAttribute('aria-describedby');
                    // titleLink.setAttribute('aria-describedby', describedBy ? `${describedBy} ${element.id}` : element.id);
                });
            });
        })
        document.querySelectorAll('.tab_se_wrap .tab_se_element:not(.ct_active)').forEach(tab => {
            setTimeout(() => {
                updateContainersVisibility(tab);

                const observer = new MutationObserver((mutations) => {
                    for (const m of mutations) {
                        if (m.type === 'attributes' && m.attributeName === 'class') {
                            const nowHas = m.target.classList.contains('lazyloaded');
                            if (nowHas) {
                                updateContainersVisibility(tab);
                                observer.disconnect();
                            }
                        }
                    }
                });

                observer.observe(tab, {
                    attributes: true,
                    attributeFilter: ['class'],
                    attributeOldValue: true
                });
            }, 1000);
        });

        const active = document.querySelector('.tab_se_element.ct_active');
        if (active) {
            fixRelatedProducts('.tab_se_element.ct_active');
        }

        function updateContainersVisibility(tab) {
            const productsContainer = tab.querySelector('.products');
            if (productsContainer) {
                productsContainer.removeAttribute('tabindex');
                tab.setAttribute('aria-hidden', 'true');
                tab.querySelectorAll('a, button').forEach(element => {
                    element.setAttribute('ally-changed', 'true');
                    element.setAttribute('tabindex', '-1');
                    element.setAttribute('aria-hidden', 'true');
                });
            }
        }
    }

    function bestSellingAppliancesListener() {
        bestSellingAppliances();


        function activateTab(selectedTab) {
            // Deactivate all tabs
            tabs.forEach(tab => {
                tab.setAttribute('aria-selected', 'false');
                tab.tabIndex = -1;
            });

            // Activate selected tab
            selectedTab.setAttribute('aria-selected', 'true');
            selectedTab.tabIndex = 0;

        }
        const tabs = document.querySelectorAll('.tab_se_wrap .tab_se_header a');

        const viewMoreBtn = document.querySelector('.tab_se_wrap .view_more');
        tabs.forEach((tab, index) => {
            tab.id = 'tab_best_' + index;

            if (index === 0) {
                const title = document.querySelector('#best_selling_id');
                if (title) {
                    document.querySelector('.tab_cat_title').setAttribute('aria-labelledby', title.id);
                }
                if (viewMoreBtn) {
                    viewMoreBtn.setAttribute('aria-describedby', tab.id);
                }
            }

            tab.addEventListener('click', () => {
                activateTab(tab);
                setTimeout(() => {
                    bestSellingAppliances();
                    if (viewMoreBtn) {
                        viewMoreBtn.setAttribute('aria-describedby', tab.id);
                        setTimeout(() => {
                            const viewMoreBtn = document.querySelector('.tab_se_element[aria-hidden="false"] .view_more');
                            if (viewMoreBtn) {
                                viewMoreBtn.setAttribute('aria-describedby', tab.id);
                            }
                        }, 2000);
                    }
                }, 500);
            });

            tab.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    activateTab(tab);
                    setTimeout(() => {
                        bestSellingAppliances();
                        setTimeout(() => {
                            const viewMoreBtn = document.querySelector('.tab_se_element[aria-hidden="false"] .view_more');
                            if (viewMoreBtn) {
                                viewMoreBtn.setAttribute('aria-describedby', tab.id);
                            }
                        }, 2000);
                    }, 500);
                    return;
                }


                let newIndex = index;
                if (e.key === 'ArrowRight') {
                    newIndex = (index + 1) % tabs.length;
                    tabs[newIndex].focus();
                } else if (e.key === 'ArrowLeft') {
                    newIndex = (index - 1 + tabs.length) % tabs.length;
                    tabs[newIndex].focus();
                } else if (e.key === 'Home') {
                    newIndex = 0;
                    tabs[newIndex].focus();
                } else if (e.key === 'End') {
                    newIndex = tabs.length - 1;
                    tabs[newIndex].focus();
                } else {
                    return; // Ignore other keys
                }

                e.preventDefault();
            })
        });
    }

    bestSellingAppliancesListener();


    function fixTopSellers() {

        const observer = new MutationObserver(() => {
            const container = document.querySelector('.splide__list');
            if (!container) return;

            setTimeout(() => {


                container.querySelectorAll('.rebuy-product-block').forEach((product, index) => {
                    product.setAttribute('aria-label', `Slide ${product.getAttribute('aria-label')}`);
                    product.removeAttribute('aria-roledescription');

                    product.querySelectorAll('img').forEach(img => {
                        img.setAttribute('alt', '');
                    });


                    const sale = product.querySelector('.rebuy-money.sale');
                    const compare = product.querySelector('.rebuy-money.compare-at');

                    if (sale && compare) {
                        const currentlyText = document.createElement('span');
                        const formerlyText = document.createElement('span');
                        currentlyText.innerText = 'Currently';
                        formerlyText.innerText = 'Formally';
                        currentlyText.classList.add('visually-hidden');
                        formerlyText.classList.add('visually-hidden');
                        sale.prepend(currentlyText);
                        compare.prepend(formerlyText);
                    }

                    const links = product.querySelectorAll('a');
                    if (links.length > 1) {
                        const titleLink = links[1];
                        replaceLinkWithSpan(links[0], titleLink);
                        titleLink.id = 'product_title_id_' + index;

                        const addToCartBtn = product.querySelector('.rebuy-button');
                        if (addToCartBtn) {
                            addToCartBtn.setAttribute('aria-describedby', titleLink.id);
                        }

                        product.querySelectorAll('.rebuy-product-review, .rebuy-product-price').forEach((element, index) => {
                            if (element.classList.contains('rebuy-product-review')) {
                                const fill = element.querySelector('.rebuy-star-rating-foreground');
                                const width = parseFloat(fill.style.width);
                                const stars = (width / 100) * 5;
                                const span = document.createElement('span');
                                span.innerText = `${stars.toFixed(1)} of 5 stars`;
                                span.classList.add('visually-hidden');
                                element.prepend(span)
                            } else {

                            }

                            element.id = `detail_${index}_${titleLink.id}`;
                            const describedBy = titleLink.getAttribute('aria-describedby');
                            titleLink.setAttribute('aria-describedby', describedBy ? `${describedBy} ${element.id}` : element.id);
                        });

                        const btn = product.querySelector('.rebuy-button');
                        if (btn) {
                            const innerText = btn.innerText;
                            btn.addEventListener('click', () => {
                                setTimeout(() => {
                                    const select = product.querySelector('.rebuy-select');
                                    if (select) {
                                        select.setAttribute('aria-labelledby', titleLink.id);
                                        select.setAttribute('aria-description', innerText);
                                    }
                                }, 200);
                            });
                        }
                    }
                    product.querySelectorAll('.rebuy-product-image, .rebuy-product-title, button').forEach(link => {

                        link.removeAttribute('alt');
                        if (link.classList.contains('rebuy-product-image')) {
                            link.removeAttribute('tabindex');
                            link.setAttribute('aria-hidden', 'true');
                        }
                        const observer = new MutationObserver((mutations) => {
                            for (const m of mutations) {
                                if (
                                    m.type === 'attributes' &&
                                    m.attributeName === 'tabindex' &&
                                    link.getAttribute('tabindex') === '0'
                                ) {
                                    const hidden = product.getAttribute('aria-hidden') === 'true';
                                    if (link.classList.contains('rebuy-product-image')) {
                                        link.removeAttribute('tabindex');
                                        link.setAttribute('aria-hidden', 'true');
                                    }
                                    if (hidden) {
                                        link.setAttribute('tabindex', '-1');
                                    }
                                }
                            }
                        });

                        observer.observe(link, { attributes: true, attributeFilter: ['tabindex'] });
                    });
                });
            }, 1000);
            observer.disconnect();
        });

        observer.observe(document.body, {
            subtree: true,
            childList: true
        });
    }

    fixTopSellers();

    function fixBlogList() {
        const blogContainer = document.querySelector('.dib-post-wrap');

        if (!blogContainer) return;

        const searchLink = document.querySelector('.dib-search-toggle a');
        if (searchLink) {
            searchLink.setAttribute('aria-label', 'Search');
            searchLink.style.padding = '5px';
            const parentLi = searchLink.parentNode;
            parentLi.style.display = 'flex';
            parentLi.style.alignItems = 'center';
            const svg = searchLink.querySelector('label svg');
            const label = svg.parentNode;
            label.replaceWith(svg);
        }

        blogContainer.setAttribute('role', 'list');
        blogContainer.querySelectorAll(':scope > a').forEach(element => {
            element.removeAttribute('title')
            const newLink = document.createElement('div');
            newLink.className = element.className;
            newLink.setAttribute('role', 'listitem');

            element.removeAttribute('aria-label');
            const img = element.querySelector('.dib-post-featured-image');
            if (img) {
                img.setAttribute('alt', '');
            }

            const title = element.querySelector('h2');
            if (title) {
                const newTitle = document.createElement('div');
                newTitle.className = title.className;
                newTitle.innerText = title.innerText;
                newTitle.classList.add('h2');
                title.replaceWith(newTitle);
            }

            const listText = element.querySelector('.dib-category-text');

            newLink.appendChild(element);


            if (listText && listText.innerText.length > 0) {
                const texts = listText.innerText.split('|');
                listText.innerText = '';
                listText.setAttribute('role', 'list');
                if (title) {
                    listText.setAttribute('aria-label', `${title.innerText} Categories`)
                }
                texts.forEach((text, index) => {
                    const listElement = document.createElement('span');
                    listElement.setAttribute('role', 'listitem');
                    listElement.innerText = text;
                    listElement.classList.add('dib-category-text');
                    listElement.style.display = "inline-block";
                    listText.appendChild(listElement);

                    if (texts.length !== index + 1) {
                        const separator = document.createElement('span');
                        separator.setAttribute('aria-hidden', 'true');
                        separator.innerText = '|'
                        separator.style.margin = '0 3px';
                        separator.style.display = "inline-block";
                        separator.classList.add('dib-category-text');
                        listText.appendChild(separator);
                    }

                });
                newLink.appendChild(listText);
            }

            blogContainer.appendChild(newLink);
        });

        const pagination = document.querySelector('.dib-pagination');
        if (pagination) {
            const links = pagination.querySelectorAll('a, .dib-pagination-current');
            const totalPages = links[links.length - 1].innerText;
            links.forEach((link) => {
                link.setAttribute('aria-label', `Page ${link.innerText} of ${totalPages}`);
                link.setAttribute('aria-current', link.classList.contains('dib-pagination-current') ? 'true' : 'false');
                if (link.classList.contains('dib-pagination-current')) {
                    link.setAttribute('role', 'link');
                    link.setAttribute('tabindex', '0');
                }
            });

            const paginationNav = document.createElement('nav');
            paginationNav.setAttribute('aria-label', 'Blog Pagination');
            paginationNav.className = pagination.className;
            paginationNav.innerHTML = pagination.innerHTML;
            pagination.replaceWith(paginationNav);
        }


    }

    fixBlogList();

    function fixBlogSearchModal() {
        if (!window.location.pathname.includes('/a/blog')) return;

        const dialog = document.querySelector('#dib-search-dialog');
        if (!dialog) return;

        const closeButton = dialog.querySelector('#dib-search-close');
        if (closeButton) {
            closeButton.removeAttribute('title');
            closeButton.setAttribute('aria-label', 'Close');
        }

        const hitsContainer = dialog.querySelector('#dib-search-hits');
        if (!hitsContainer) return;

        const searchField = dialog.querySelector('.dib-search-box-input');

        function fixResultsMarkup() {
            const container = hitsContainer.querySelector('.ais-Hits-list.dib-search-hits-list');
            container?.setAttribute('role', 'none');
            hitsContainer.querySelectorAll('.ais-Hits-list.dib-search-hits-list').forEach(list => {
                list.querySelectorAll('h4').forEach(heading => {
                    const newHeading = document.createElement('h2');
                    copyAttributes(heading, newHeading);
                    newHeading.innerHTML = heading.innerHTML;
                    newHeading.classList.add('h4');
                    heading.replaceWith(newHeading);
                });
            });
        }

        fixResultsMarkup();

        const markupObserver = new MutationObserver(fixResultsMarkup);
        markupObserver.observe(hitsContainer, { subtree: true, childList: true });

        if (searchField) {
            fixBlogSearchAccessibility(searchField, hitsContainer);
        }
    }

    function fixBlogSearchAccessibility(searchField, hitsContainer) {
        const itemSelector = '.dib-search-hits-item';
        const selectedClass = 'dib-search-hits-item-selected';
        const getItems = () => Array.from(hitsContainer.querySelectorAll(itemSelector));
        let lastResultCount = -1;

        let statusElement = document.querySelector('#dib-search-status');
        if (!statusElement) {
            statusElement = document.createElement('div');
            statusElement.id = 'dib-search-status';
            statusElement.setAttribute('role', 'status');
            statusElement.setAttribute('aria-live', 'polite');
            statusElement.setAttribute('aria-atomic', 'true');
            statusElement.className = 'visually-hidden';
            hitsContainer.parentElement.insertBefore(statusElement, hitsContainer);
        }

        hitsContainer.setAttribute('role', 'listbox');
        hitsContainer.setAttribute('aria-label', 'Blog search results');

        searchField.setAttribute('role', 'combobox');
        searchField.setAttribute('aria-expanded', 'false');
        searchField.setAttribute('aria-autocomplete', 'list');
        searchField.setAttribute('aria-controls', 'dib-search-hits');
        searchField.setAttribute('aria-owns', 'dib-search-hits');
        searchField.setAttribute('aria-haspopup', 'listbox');

        let currentIndex = -1;

        function announceResults(count) {
            if (count === lastResultCount) return;
            lastResultCount = count;
            statusElement.textContent = count === 0 ? 'No results found' : `${count} results found`;
        }

        function updateItemsAttributes() {
            const items = getItems();
            items.forEach((item, index) => {
                item.querySelectorAll('mark').forEach(mark => mark.setAttribute('role', 'none'));
                item.setAttribute('role', 'option');
                if (!item.id) item.id = 'blog-option-' + index;
                item.setAttribute('aria-selected', 'false');
                const link = item.querySelector('a');
                if (link) link.setAttribute('tabindex', '-1');
            });
            searchField.setAttribute('aria-expanded', items.length > 0 ? 'true' : 'false');
            announceResults(items.length);
        }

        function setActiveOption(index) {
            const items = getItems();

            items.forEach(item => {
                item.classList.remove(selectedClass);
                item.setAttribute('aria-selected', 'false');
            });

            searchField.removeAttribute('aria-activedescendant');

            if (index >= 0 && index < items.length) {
                const activeItem = items[index];
                activeItem.classList.add(selectedClass);
                activeItem.setAttribute('aria-selected', 'true');
                searchField.setAttribute('aria-activedescendant', activeItem.id);
                activeItem.scrollIntoView({ block: 'nearest' });
                currentIndex = index;
            } else {
                currentIndex = -1;
            }
        }

        searchField.addEventListener('keydown', (e) => {
            const items = getItems();
            if (items.length === 0) return;

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                let nextIndex = currentIndex + 1;
                if (nextIndex >= items.length) nextIndex = 0;
                setActiveOption(nextIndex);
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                let prevIndex = currentIndex - 1;
                if (prevIndex < 0) prevIndex = items.length - 1;
                setActiveOption(prevIndex);
            } else if (e.key === 'Enter') {
                if (currentIndex >= 0 && items[currentIndex]) {
                    const link = items[currentIndex].querySelector('a');
                    if (link) {
                        e.preventDefault();
                        link.click();
                    }
                }
            } else if (e.key === 'Escape') {
                setActiveOption(-1);
                searchField.setAttribute('aria-expanded', 'false');
            }
        });

        searchField.addEventListener('input', () => {
            currentIndex = -1;
            searchField.removeAttribute('aria-activedescendant');
            setTimeout(updateItemsAttributes, 100);
        });

        searchField.addEventListener('focus', () => {
            updateItemsAttributes();
        });

        updateItemsAttributes();

        const observer = new MutationObserver(() => {
            updateItemsAttributes();
            if (currentIndex >= getItems().length) {
                setActiveOption(-1);
            }
        });

        observer.observe(hitsContainer, { subtree: true, childList: true });
    }

    fixBlogSearchModal();

    function fixBlogCategoryMenu() {
        const blogContainer = document.querySelector('#dib-posts');
        if (!blogContainer) return;

        const categoryMenu = blogContainer.querySelector('.dib-cat-menu');
        if (!categoryMenu) return;

        categoryMenu.setAttribute('aria-label', 'categories');

        const searchToggle = categoryMenu.querySelector('.dib-search-toggle');
        if (searchToggle) {
            const searchLink = searchToggle.querySelector('a');
            if (searchLink) {
                const onclickHandler = searchToggle.getAttribute('onclick');

                searchToggle.remove();

                const searchContainer = document.createElement('div');
                searchContainer.setAttribute('role', 'search');
                searchContainer.setAttribute('aria-label', 'Blog');
                if (onclickHandler) {
                    searchContainer.setAttribute('onclick', onclickHandler);
                }

                const newSearchButton = document.createElement('a');
                copyAttributes(searchLink, newSearchButton);
                newSearchButton.setAttribute('role', 'button');
                newSearchButton.innerHTML = searchLink.innerHTML;

                searchContainer.appendChild(newSearchButton);

                const wrapper = document.createElement('div');
                wrapper.classList.add('dib-menu-wrapper');

                categoryMenu.parentNode.insertBefore(wrapper, categoryMenu);

                wrapper.appendChild(searchContainer);
                wrapper.appendChild(categoryMenu);

                categoryMenu.style.border = 'none';
                categoryMenu.style.margin = '0';
                categoryMenu.style.padding = '0';
                categoryMenu.style.position = 'static';
                categoryMenu.style.transform = 'none';
                categoryMenu.style.left = 'auto';
                categoryMenu.style.width = 'auto';

                searchContainer.style.cssText = 'display: flex; align-items: center; flex: 0 0 auto; padding: 0; margin: 0;';
            }
        }

        const normalizePath = (value = '') => value.replace(/\/$/, '');
        const currentPath = normalizePath(window.location.pathname);

        categoryMenu.querySelectorAll('a').forEach(link => {
            if (link.closest('.dib-search-toggle')) {
                link.removeAttribute('aria-current');
                return;
            }

            const rawHref = link.getAttribute('href') || '';
            const linkPath = normalizePath(link.pathname || rawHref);
            const isCurrent = link.classList.contains('current') ||
                link.classList.contains('"current"') ||
                linkPath === currentPath;

            link.setAttribute('aria-current', isCurrent ? 'true' : 'false');
        });
    }

    fixBlogCategoryMenu();

    function fixBlogReadtime() {
        const blogContainer = document.querySelector('#dib-posts');
        if (!blogContainer) return;

        const relatedPosts = document.querySelectorAll('.dib-related-post');

        relatedPosts.forEach((post, index) => {
            const readtime = post.querySelector('.dib-post-readtime');
            const titleLink = post.querySelector('.dib-post-title-link');

            if (readtime && titleLink && !readtime.id) {
                const readtimeId = `blog-readtime-${index + 1}`;
                readtime.id = readtimeId;
                titleLink.setAttribute('aria-describedby', readtimeId);
            }
        });
    }

    fixBlogReadtime();

    function fixBackToBlogLink() {
        const blogContainer = document.querySelector('#dib-posts');
        if (!blogContainer) return;

        const backLinks = document.querySelectorAll('.dib-post-back-link');

        backLinks.forEach(link => {
            const text = link.textContent;
            if (text.startsWith('« ')) {
                const arrowSpan = document.createElement('span');
                arrowSpan.setAttribute('aria-hidden', 'true');
                arrowSpan.textContent = '« ';

                link.textContent = text.replace('« ', '');
                link.insertBefore(arrowSpan, link.firstChild);
            }
        });
    }

    fixBackToBlogLink();

    function fixTrackingPage() {
        const trackContainer = document.querySelector('#pp-tracking-page-app');
        if (!trackContainer) return;

        trackContainer.querySelectorAll('.pp_tracking_form_in .pp_tracking_parent').forEach((parent, index) => {
            const labelText = parent.querySelector('.pp_tracking_span');
            const input = parent.querySelector('input');
            if (labelText && input) {
                labelText.innerText = labelText.innerText + ' *';
                labelText.id = 'label_id_' + index;
                input.setAttribute('aria-labelledby', labelText.id);
            }
        });

        const submitBtn = trackContainer.querySelector('.pp_tracking_form_order .pp_tracking_button button');
        if (submitBtn) {
            submitBtn.addEventListener('click', () => fixErrorTextForInputs('.pp_tracking_form_order'));
        }

        const submitBtn2 = trackContainer.querySelector('.pp_tracking_form_number .pp_tracking_button button');
        if (submitBtn2) {
            submitBtn2.addEventListener('click', () => fixErrorTextForInputs('.pp_tracking_form_number', true));
        }

        changeH1toDivAlert();

        const observer = new MutationObserver(() => {
            changeH1toDivAlert();
        });

        observer.observe(trackContainer, {
            subtree: true,
            childList: true
        });

        function changeH1toDivAlert() {
            const notFoundText = document.querySelector('h1.pp_tracking_result_title');
            if (!notFoundText) return;
            const newText = document.createElement('div');
            copyAttributes(notFoundText, newText);
            newText.innerText = notFoundText.innerText;
            newText.setAttribute('role', 'alert');
            notFoundText.replaceWith(newText);
        }

        function fixErrorTextForInputs(containerID, isAlert) {
            const parents = trackContainer.querySelectorAll(containerID + ' .pp_tracking_input:has(.pp_tracking_alert)');

            trackContainer.querySelectorAll(containerID + ' .pp_tracking_input .pp_tracking_alert').forEach((element, index) => {

                if (isAlert) {
                    element.setAttribute('role', 'alert');
                    return;
                }
                const input = parents[index].querySelector('input');
                const id = input.getAttribute('name') + "_id";
                element.id = id;
                input.setAttribute('aria-describedby', id);
                if (index === 0) {
                    input.focus();
                }
            });
        }
    }

    fixTrackingPage();

    function fixTrackingPage() {
        const trackContainer = document.querySelector('#pp-tracking-page-app');
        if (!trackContainer) return;

        trackContainer.querySelectorAll('.pp_tracking_form_in .pp_tracking_parent').forEach((parent, index) => {
            const labelText = parent.querySelector('.pp_tracking_span');
            const input = parent.querySelector('input');
            if (labelText && input) {
                labelText.innerText = labelText.innerText + ' *';
                labelText.id = 'label_id_' + index;
                input.setAttribute('aria-labelledby', labelText.id);
            }
        });

        const submitBtn = trackContainer.querySelector('.pp_tracking_form_order .pp_tracking_button button');
        if (submitBtn) {
            submitBtn.addEventListener('click', () => fixErrorTextForInputs('.pp_tracking_form_order'));
        }

        const submitBtn2 = trackContainer.querySelector('.pp_tracking_form_number .pp_tracking_button button');
        if (submitBtn2) {
            submitBtn2.addEventListener('click', () => fixErrorTextForInputs('.pp_tracking_form_number', true));
        }

        changeH1toDivAlert();

        const observer = new MutationObserver(() => {
            changeH1toDivAlert();
        });

        observer.observe(trackContainer, {
            subtree: true,
            childList: true
        });

        function changeH1toDivAlert() {
            const notFoundText = document.querySelector('h1.pp_tracking_result_title');
            if (!notFoundText) return;
            const newText = document.createElement('div');
            copyAttributes(notFoundText, newText);
            newText.innerText = notFoundText.innerText;
            newText.setAttribute('role', 'alert');
            notFoundText.replaceWith(newText);
        }

        function fixErrorTextForInputs(containerID, isAlert) {
            const parents = trackContainer.querySelectorAll(containerID + ' .pp_tracking_input:has(.pp_tracking_alert)');

            trackContainer.querySelectorAll(containerID + ' .pp_tracking_input .pp_tracking_alert').forEach((element, index) => {

                if (isAlert) {
                    element.setAttribute('role', 'alert');
                    return;
                }
                const input = parents[index].querySelector('input');
                const id = input.getAttribute('name') + "_id";
                element.id = id;
                input.setAttribute('aria-describedby', id);
                if (index === 0) {
                    input.focus();
                }
            });
        }
    }

    fixTrackingPage();

    function fixShopTheLook() {
        const container = document.querySelector('.evm_lookbook_block');
        if (!container) return;

        const slideshow = document.querySelector('.slideshow');

        if (slideshow) {
            slideshow.removeAttribute('tabindex');
        }
        let currentIndex = 1;
        const observer = new MutationObserver(() => {
            const list = container.querySelector('.EVMLookbookgrid');
            if (!list) return;
            list.querySelectorAll('.evmhash').forEach((element, index) => {
                element.style.cursor = 'pointer';
                element.setAttribute('aria-label', `Customer's space ${currentIndex}`);
                element.addEventListener('click', () => {
                    setTimeout(() => fixModal(), 1000);
                });
                currentIndex++;
                observeLI(element.closest('li'));
            });
            list.querySelectorAll('.evmhash .evm-list a').forEach(element => {
                element.style.cursor = 'pointer';
                element.removeAttribute('href');
                element.setAttribute('tabindex', '-1');
                element.setAttribute('aria-hidden', 'true');
            });

            document.querySelectorAll('.evm_lookbook_detail').forEach(popup => {
                const links = popup.querySelectorAll('.evm_shop_now_container a, .evm_lookbook_detail_content a');
                if (links.length > 1) {
                    replaceLinkWithSpan(links[0], links[1]);
                }
            });

            const observerUL = new MutationObserver((mutations) => {
                mutations.forEach(mutation => {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeName === 'LI') {
                            const items = node.querySelectorAll('a');
                            observeLI(node);
                            if (items.length) {
                                items.forEach((innerLink, index) => {
                                    if (index === 0) {
                                        innerLink.setAttribute('aria-label', `Customer's space ${currentIndex}`);
                                        innerLink.style.cursor = 'pointer';
                                        innerLink.addEventListener('click', () => {
                                            setTimeout(() => fixModal(), 1000);
                                        });
                                    } else {
                                        innerLink.style.cursor = 'pointer';
                                        innerLink.removeAttribute('href');
                                        innerLink.setAttribute('tabindex', '-1');
                                        innerLink.setAttribute('aria-hidden', 'true');
                                    }
                                });
                            } else {
                                node.querySelector('img').setAttribute('alt', `Customer's space ${currentIndex}`)
                            }
                            currentIndex++;
                        }
                    });
                });
            });

            observerUL.observe(list, {
                childList: true
            });


            observer.disconnect();
        });

        observer.observe(container, {
            subtree: true,
            childList: true
        });

        function observeLI(li) {
            const update = (node) => {
                if (node.getAttribute('aria-label') || node.closest('.evm_lookbook_detail')) return
                node.style.cursor = 'pointer';
                node.removeAttribute('href');
                node.setAttribute('tabindex', '-1');
                node.setAttribute('aria-hidden', 'true');
            };
            const observerLI = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1 && node.tagName === "A") update(node);
                        if (node.nodeType === 1) {
                            const links = node.querySelectorAll("a");
                            links.forEach(link => update(link));
                        }
                    });
                });
            });
            observerLI.observe(li, { childList: true, subtree: true });
        }

        function fixModal() {
            const modal = document.querySelector('.evm_fancybox-overlay:has(a), .evm_fancybox-opened:has(a)');
            if (!modal) return;
            modal.querySelectorAll('.evm_tag_view a').forEach(link => {
                link.removeAttribute('aria-hidden');
                link.setAttribute('tabindex', '0')
            })
            modal.setAttribute('role', 'dialog');
            const classId = modal.querySelector('.evm_tag_view');
            const id = classId.id.split('_').pop();
            const elementID = document.getElementById(id);
            modal.setAttribute('aria-label', elementID.getAttribute('aria-label'));

            const focusableElements = modal.querySelectorAll('.evm_fancybox-skin .evm_fancybox-close, .evm_fancybox-skin .evm_fancybox-nav, .evm_fancybox-skin .evm_fancybox-outer .evm-list .evm_tag_view > a');
            modal.querySelectorAll('.evm_fancybox-skin .evm_fancybox-close, .evm_fancybox-skin .evm_fancybox-nav').forEach(element => {
                element.setAttribute('aria-label', element.getAttribute('title'));
                element.removeAttribute('title');
            });

            trapFocusReuse(modal, elementID, focusableElements);
            fixModalControls(modal, elementID);

            focusableElements.forEach(element => {
                const popup = element.nextElementSibling;
                if (popup && popup.classList.contains('evm_lookbook_detail')) {
                    const title = popup.querySelector('.evm_look_book_title');
                    if (title) {
                        element.setAttribute('aria-label', `Open ${title.innerText} modal`);
                    }
                    popup.setAttribute('role', 'dialog');
                    popup.setAttribute('aria-modal', 'true');
                    handleEnterKeyAndEscapeKey(element, popup);
                    handleClickEventAndKeydown(element, popup);
                }
            });

            const observer = new MutationObserver(() => {
                const innerWrap = modal.querySelector('.evm_fancybox-wrap');
                if (!innerWrap) return;

                setTimeout(() => {
                    fixModal(elementID);
                }, 500)

                observer.disconnect();
            });

            observer.observe(modal, {
                subtree: true,
                childList: true
            });
        }

        function handleEnterKeyAndEscapeKey(btn, popup) {
            btn.addEventListener('keydown', (e) => {
                if (e.key !== 'Enter' || e.repeat) return;
                let onPopupKeydown;

                e.preventDefault();
                e.stopPropagation();

                popup.classList.toggle('toggleModal');
                trapFocusReuse(popup, btn);

                if (onPopupKeydown) {
                    popup.removeEventListener('keydown', onPopupKeydown, true); // capture flag must match
                }


                onPopupKeydown = function (ev) {
                    if (ev.key === 'Escape') {
                        ev.preventDefault();
                        ev.stopPropagation();
                        popup.classList.toggle('toggleModal'); // close inner
                        popup.removeEventListener('keydown', onPopupKeydown, true);
                        onPopupKeydown = null;
                        btn.focus();
                    }
                };
                popup.addEventListener('keydown', onPopupKeydown, { capture: true });
            }, { capture: true });
        }

        function handleClickEventAndKeydown(btn, popup) {
            let onPopupKeydown;
            btn.addEventListener('click', () => {
                popup.classList.toggle('toggleModal');
                if (popup.classList.contains('toggleModal')) {
                    trapFocusReuse(popup, btn);
                    if (onPopupKeydown) {
                        popup.removeEventListener('keydown', onPopupKeydown, true);
                    }

                    onPopupKeydown = function (ev) {
                        if (ev.key === 'Escape') {
                            ev.preventDefault();
                            ev.stopPropagation();
                            popup.classList.toggle('toggleModal');
                            popup.removeEventListener('keydown', onPopupKeydown, true);
                            onPopupKeydown = null;
                            btn.focus();
                        }
                    };
                    popup.addEventListener('keydown', onPopupKeydown, { capture: true });
                }
            });
        }

        function fixModalControls(modal, btn) {
            const closeButton = modal.querySelector('.evm_fancybox-close');
            fixModalControlActivation(closeButton, 'evmKbClose', btn);

            modal.querySelectorAll('.evm_fancybox-nav').forEach(navBtn => {
                fixModalControlActivation(navBtn, navBtn.classList.contains('evm_fancybox-prev') ? 'evmKbPrev' : 'evmKbNext');
            });
        }

        function fixModalControlActivation(element, flag, btn) {
            if (!element || element.dataset[flag]) return;
            element.dataset[flag] = 'true';

            element.setAttribute('role', element.getAttribute('role') || 'button');
            element.addEventListener('click', () => {
                if(btn) {
                    btn.focus();
                }
            });
            element.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    event.stopPropagation();
                    element.click();
                    if(btn) {
                        btn.focus();
                    }
                }
            });
        }
    }

    fixShopTheLook()

    function fixSlideshowTabindex() {
        const apply = () => {
            const slideshows = document.querySelectorAll('.slideshow[tabindex]');
            if (!slideshows.length) return;

            slideshows.forEach(slideshow => {
                slideshow.removeAttribute('tabindex');
            });
        };

        setTimeout(apply, 500);
        apply();

        const observer = new MutationObserver(() => {
            apply();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    fixSlideshowTabindex()

    function fixPriceSlider() {

        function applyKeyboardNavigation() {
            const filterContainer = document.querySelector('#boost-sd-filter-tree-column');
            if (!filterContainer) {
                return;
            }


            const sliderContainer = filterContainer.querySelector('.boost-sd__filter-option-range-slider-slider.noUi-target');

            if (!sliderContainer) return;

            const handleLower = sliderContainer.querySelector('.noUi-handle-lower');
            const handleUpper = sliderContainer.querySelector('.noUi-handle-upper');

            if (!handleLower || !handleUpper) return;

            if (handleLower.hasAttribute('data-keyboard-enabled')) {
                return;
            }

            const getSliderValues = () => {
                const valueMin = parseFloat(handleLower.getAttribute('aria-valuemin'));
                const valueMax = parseFloat(handleLower.getAttribute('aria-valuemax'));
                const currentMin = parseFloat(handleLower.getAttribute('aria-valuenow'));
                const currentMax = parseFloat(handleUpper.getAttribute('aria-valuenow'));

                return { valueMin, valueMax, currentMin, currentMax };
            };

            const getStep = () => {
                const { valueMin, valueMax } = getSliderValues();
                return Math.max((valueMax - valueMin) / 100, 1);
            };

            const updateHandlePosition = (handle, value, isLower) => {
                const { valueMin, valueMax } = getSliderValues();
                const percentage = ((value - valueMin) / (valueMax - valueMin)) * 100;

                handle.setAttribute('aria-valuenow', value);
                handle.setAttribute('aria-valuetext', value);

                const origin = handle.closest('.noUi-origin');
                if (origin) {
                    origin.style.transform = `translate(${percentage - 100}%, 0px)`;
                }

                const inputType = isLower ? 'min' : 'max';
                const input = filterContainer.querySelector(`input[data-type="${inputType}"]`);
                if (input) {
                    input.value = value;

                    setTimeout(() => {
                        input.value = value;
                    }, 0);

                    const inputEvent = new Event('input', { bubbles: true });
                    input.dispatchEvent(inputEvent);
                }

                const sliderEvent = new Event('input', { bubbles: true });
                sliderContainer.dispatchEvent(sliderEvent);

            };

            const applyFilter = (handleToFocus) => {
                const changeEvent = new Event('change', { bubbles: true });
                sliderContainer.dispatchEvent(changeEvent);

                const setEvent = new Event('set', { bubbles: true });
                sliderContainer.dispatchEvent(setEvent);

                const inputMin = filterContainer.querySelector('input[data-type="min"]');
                const inputMax = filterContainer.querySelector('input[data-type="max"]');

                if (inputMin) {
                    const changeEventMin = new Event('change', { bubbles: true });
                    inputMin.dispatchEvent(changeEventMin);
                }

                if (inputMax) {
                    const changeEventMax = new Event('change', { bubbles: true });
                    inputMax.dispatchEvent(changeEventMax);
                }


                setTimeout(() => {
                    if (handleToFocus) {
                        handleToFocus.focus();
                    }
                }, 100);
            };

            handleLower.addEventListener('keydown', (event) => {
                const { valueMin, currentMin, currentMax } = getSliderValues();
                const step = getStep();
                let newMin = currentMin;
                let handled = false;

                if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
                    newMin = Math.min(currentMin + step, currentMax);
                    handled = true;
                } else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
                    newMin = Math.max(currentMin - step, valueMin);
                    handled = true;
                } else if (event.key === 'Enter') {
                    applyFilter(handleLower);
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }

                if (handled) {
                    updateHandlePosition(handleLower, newMin, true);
                    event.preventDefault();
                    event.stopPropagation();
                }
            });

            handleLower.setAttribute('data-keyboard-enabled', 'true');

            handleUpper.addEventListener('keydown', (event) => {
                const { valueMax, currentMin, currentMax } = getSliderValues();
                const step = getStep();
                let newMax = currentMax;
                let handled = false;

                if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
                    newMax = Math.min(currentMax + step, valueMax);
                    handled = true;
                } else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
                    newMax = Math.max(currentMax - step, currentMin);
                    handled = true;
                } else if (event.key === 'Enter') {
                    applyFilter(handleUpper);
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }

                if (handled) {
                    console.log('[fixPriceSlider] Upper handle - Key pressed:', event.key, 'New value:', newMax);
                    updateHandlePosition(handleUpper, newMax, false);
                    event.preventDefault();
                    event.stopPropagation();
                }
            });

            handleUpper.setAttribute('data-keyboard-enabled', 'true');
            console.log('[fixPriceSlider] Keyboard listeners attached successfully');
        }

        applyKeyboardNavigation();

        const observer = new MutationObserver(() => {
            applyKeyboardNavigation();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    fixPriceSlider();

    function fixDescribeSearchThumbnail() {
        if (!window.location.pathname.includes('/search') && !window.location.pathname.includes('/collections')) return;

        function applyToSearchThumbnails() {
            // const searchContainer = document.querySelector('.boost-sd-container-search-page');
            // if (!searchContainer) return;

            const productList = document.querySelector('.boost-sd__product-list');
            if (!productList) return;

            const thumbnails = productList.querySelectorAll('.boost-sd__product-item');
            thumbnails.forEach((thumbnail, index) => {
                if (!(thumbnail instanceof Element)) return;

                const title = thumbnail.querySelector('.boost-sd__product-title');
                if (!title) return;

                const titleId = `search_product_title_${index}`;
                title.id = titleId;

                const quickViewButton = thumbnail.querySelector('.boost-sd__button--quick-view');
                if (quickViewButton) {
                    quickViewButton.setAttribute('aria-describedby', titleId);
                }

                const addToCartButton = thumbnail.querySelector('.boost-sd__button--select-option, .boost-sd__button--add-to-cart, .boost-sd__button--primary');
                if (addToCartButton) {
                    addToCartButton.setAttribute('aria-describedby', titleId);
                }

                const ratingButton = thumbnail.querySelector('.boost-sd__product-rating [role="button"], .boost-sd__product-rating button');
                if (ratingButton) {
                    ratingButton.setAttribute('aria-describedby', titleId);
                }

                const stars = thumbnail.querySelector('.jdgm-prev-badge__stars');
                if(stars) {
                    stars.removeAttribute('tabindex');
                    stars.setAttribute('aria-label', `${stars.getAttribute('data-score')} out of 5 stars`);
                    stars.setAttribute('role', 'img');
                }
            });
        }

        applyToSearchThumbnails();

        const observer = new MutationObserver(() => applyToSearchThumbnails());
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });
    }

    fixDescribeSearchThumbnail();

    function replaceFilterDivWithSection() {
        if (!window.location.pathname.includes('/search') && !window.location.pathname.includes('/collections')) return;

        function replace(filterDiv) {
            if (filterDiv.tagName !== 'DIV') return;

            const section = document.createElement('section');
            copyAttributes(filterDiv, section);
            section.setAttribute('aria-label', 'filter');
            section.innerHTML = filterDiv.innerHTML;
            filterDiv.replaceWith(section);
        }

        function apply(root = document) {
            const filterDiv = root.querySelector('#boost-sd-filter-tree-column');
            if (filterDiv && filterDiv.tagName === 'DIV') {
                replace(filterDiv);
            }
        }

        apply();

        const observer = new MutationObserver(() => apply());

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    replaceFilterDivWithSection();

    function fixFilterCheckboxAccessibility() {
        if (!window.location.pathname.includes('/search') && !window.location.pathname.includes('/collections')) return;

        function applyToFilterCheckboxes() {
            const filterContainers = document.querySelectorAll('.boost-sd__filter-tree-wrapper');
            if (filterContainers.length === 0) return;



            filterContainers.forEach(container => {
                const checkboxButtons = container.querySelectorAll('.boost-sd__filter-option-item-button[role="checkbox"]');
                const list = container.querySelector('.boost-sd__filter-tree-vertical-option-list');
                if(list) {
                    list.setAttribute('role', 'list');
                    list.querySelectorAll(':scope > .boost-sd__filter-option-list').forEach(item => {
                        item.setAttribute('role', 'listitem');
                    });
                }
                checkboxButtons.forEach((button, index) => {
                    if (!(button instanceof Element)) return;

                    const labelSpan = button.querySelector('.boost-sd__filter-option-item-label');
                    const amountSpan = button.querySelector('.boost-sd__filter-option-item-amount');

                    if (!labelSpan || !amountSpan) return;

                    const labelId = `filter_label_$`+ Math.random().toString(36).substr(2, 9);
                    const amountId = `filter_amount_$`+ Math.random().toString(36).substr(2, 9);

                    if (!labelSpan.id) {
                        labelSpan.id = labelId;
                        amountSpan.id = amountId;

                        if (button.hasAttribute('aria-label')) {
                            button.removeAttribute('aria-label');
                        }

                        if (amountSpan.hasAttribute('aria-label')) {
                            amountSpan.removeAttribute('aria-label');
                        }

                        button.setAttribute('aria-labelledby', `${labelId} ${amountId}`);
                    }
                });
            });
        }

        applyToFilterCheckboxes();

        const observer = new MutationObserver(() => applyToFilterCheckboxes());
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'aria-label']
        });
    }

    fixFilterCheckboxAccessibility();

    function labelFilterGroups() {
        if (!window.location.pathname.includes('/collections/') && !window.location.pathname.includes('/search')) return;

        const selector = '.boost-sd__filter-option-label[id$="-toggle-target-label"]';

        const updateLabel = (label) => {
            if (!label || label.hasAttribute('data-a11y-processed')) return;

            const labelId = label.id;
            const baseId = labelId.replace('-toggle-target-label', '');
            const wrapperId = `${baseId}-toggle-target`;
            const wrapper = document.getElementById(wrapperId);

            if (!wrapper || !wrapper.classList.contains('boost-sd__filter-option-itemwrapper')) return;

            wrapper.setAttribute('role', 'group');
            wrapper.setAttribute('aria-labelledby', labelId);

            label.setAttribute('data-a11y-processed', 'true');
            wrapper.setAttribute('data-a11y-processed', 'true');
        };

        const apply = (root = document) => {
            if (root.matches?.(selector)) {
                updateLabel(root);
            }

            root.querySelectorAll?.(selector).forEach(updateLabel);
        };

        apply();

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                apply(mutation.target);
                mutation.addedNodes.forEach(node => apply(node));
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    labelFilterGroups();

    function removeSearchAttributes() {
        if (!window.location.pathname.includes('/search')) return;

        const cleanSearchInputs = () => {
            const searchInputs = document.querySelectorAll('.boost-sd__search-form-input.boost-sd__search-widget-init-input');
            if (!searchInputs.length) return;

            searchInputs.forEach(input => {
                input.removeAttribute('role');
                input.removeAttribute('aria-expanded');
            });
        };

        cleanSearchInputs();

        const observer = new MutationObserver((mutations) => {
            if (!mutations || !mutations.length) return;
            cleanSearchInputs();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    removeSearchAttributes();

    function fixBlogImagesAlt() {
        if (!window.location.pathname.includes('/blog/')) return;
        const postContainer = document.querySelector('.dib-post-single');
        if (!postContainer) return;

        const featuredImage = postContainer.querySelector('.dib-post-featured-image img');
        if (featuredImage) {
            const alt = featuredImage.getAttribute('alt');
            const isAltActive = alt ? alt.endsWith("..") : false;
            if (!isAltActive) {
                featuredImage.setAttribute('alt', '');
            }

        }
    }

    fixBlogImagesAlt();

    function fixJudgeMeCarousel() {
        const ROOT_SEL = '.jdgm-carousel-wrapper';
        const parentContainer = document.querySelector(ROOT_SEL);
        if (!parentContainer) return;
        const ratingParent = parentContainer.querySelector('.jdgm-all-reviews-rating');
        if (ratingParent) {
            ratingParent.removeAttribute('tabindex');
            ratingParent.setAttribute('aria-label', `${ratingParent.getAttribute('data-score')} out of 5 stars`);
        }
        const invisibleAlert = document.querySelector('#invisible-alert');

        parentContainer.addEventListener('focusout', (e) => {
            if (!parentContainer.contains(e.relatedTarget)) {
                invisibleAlert.setAttribute('aria-hidden', 'true');
                invisibleAlert.innerHTML = '';

            }
        });
        parentContainer.querySelectorAll('.jdgm-carousel__arrows .jdgm-carousel__left-arrow, .jdgm-carousel__arrows .jdgm-carousel__right-arrow').forEach((btn, index) => {
            btn.setAttribute('role', 'button');
            if (index === 0) {
                btn.setAttribute('aria-label', 'Previous review');
            } else {
                btn.setAttribute('aria-label', 'Next review');
            }
        })

        // ------------   Toggle visibility attributes for active items   ----------

        const wrapper = document.querySelector('.jdgm-carousel-wrapper');
        if (!wrapper) return;

        const viewport = wrapper.querySelector('.jdgm-carousel__item-container');
        const track = wrapper.querySelector('.jdgm-carousel__item-wrapper');
        if (!viewport || !track) return;
        const FOCUSABLE = 'a[href]';
        const VISIBLE_RATIO = 0.6;

        const qAll = (sel, root = document) => Array.from(root.querySelectorAll(sel));

        function setSlideFocusable(slide, visible) {
            const links = qAll(FOCUSABLE, slide);
            if (visible) {
                links.forEach(a => a.removeAttribute('tabindex'));
                slide.setAttribute('aria-hidden', 'false');
            } else {
                links.forEach(a => a.tabIndex = -1);
                slide.setAttribute('aria-hidden', 'true');
            }
        }
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                    const togleBtn = document.querySelector('.jdgm-carousel-toggle');
                    setTimeout(() => {
                        if (togleBtn.getAttribute('aria-label') !== 'Resume carousel autoplay') return;
                        const allItems = track.querySelectorAll('.jdgm-carousel-item');
                        const items = Array.from(allItems).filter(item => item.getAttribute('aria-hidden') !== 'true');
                        if (items.length > 0) {
                            if (items.length > 1) {
                                const middleOne = items[Math.floor(items.length / 2)];
                                if (middleOne) {
                                    const next = middleOne.nextElementSibling;
                                    invisibleAlert.removeAttribute('aria-hidden');
                                    invisibleAlert.innerHTML = middleOne.querySelector('.jdgm-carousel-item__review-content').innerHTML;
                                }
                            } else if (items.length === 1) {
                                invisibleAlert.removeAttribute('aria-hidden');

                                invisibleAlert.innerHTML = items[0].querySelector('.jdgm-carousel-item__review-content').innerHTML;
                            }

                        }
                    }, 400);

                }
            });
        });

        // Start observing the target
        observer.observe(track, {
            attributes: true,
            attributeFilter: ['style'],
        });

        // Observe each slide's visibility within the carousel viewport
        const io = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                setSlideFocusable(entry.target, entry.intersectionRatio >= VISIBLE_RATIO);
            }
        }, { root: viewport, threshold: [0, 0.25, VISIBLE_RATIO, 0.75, 1] });

        // Start observing existing slides
        function observeAllSlides() {
            qAll('.jdgm-carousel-item', track).forEach(slide => io.observe(slide));
        }
        observeAllSlides();

        // If slides get added later, observe them too
        const mo = new MutationObserver((muts) => {
            muts.forEach(m => {
                m.addedNodes.forEach(n => {
                    if (n.nodeType === 1) {
                        if (n.matches?.('.jdgm-carousel-item')) io.observe(n);
                        n.querySelectorAll?.('.jdgm-carousel-item').forEach(el => io.observe(el));
                    }
                });
            });
        });
        mo.observe(track, { childList: true, subtree: true });

        // Initial pass (before IntersectionObserver fires)
        const vRect = viewport.getBoundingClientRect();

        const carouselItems = qAll('.jdgm-carousel-item', track);
        carouselItems.forEach((slide, index) => {
            const r = slide.getBoundingClientRect();
            const overlapX = Math.max(0, Math.min(r.right, vRect.right) - Math.max(r.left, vRect.left));
            const ratio = r.width ? overlapX / r.width : 0;
            setSlideFocusable(slide, ratio >= VISIBLE_RATIO);

            slide.setAttribute('role', 'group');
            slide.setAttribute('aria-label', `Review ${index + 1} of ${carouselItems.length}`);
        });


        parentContainer.querySelectorAll('.jdgm-carousel-item__product').forEach(item => {
            const img = item.querySelector('.jdgm-carousel-item__product-image');
            img.setAttribute('alt', '');
            const title = item.querySelector('.jdgm-carousel-item__product-title');
            title.setAttribute('aria-hidden', 'true');
            item.setAttribute('aria-label', title.innerText);

            const parent = item.parentElement;
            const ratingImg = parent.querySelector('.jdgm-carousel-item__review-rating');
            if(ratingImg) {
                ratingImg.removeAttribute('tabindex');
                const aria = ratingImg.getAttribute('aria-label');
                const number = parseInt(aria.replace(/\D+/g, ''), 10);
                ratingImg.setAttribute('aria-label', `${number} out of 5 stars`);
            }
        });

        // ------------   Pause and play carousel   ----------
        const E_HOVER_IN = ['mouseenter', 'mouseover'];
        const E_HOVER_OUT = ['mouseleave', 'mouseout'];
        const ALL_HOVER = [...E_HOVER_IN, ...E_HOVER_OUT];

        function $(sel, root = document) { return root.querySelector(sel); }

        function whenReady(cb) {
            const tryStart = () => {
                const root = $(ROOT_SEL);
                if (root && root.querySelector('.jdgm-carousel__item-wrapper')) { cb(root); return true; }
                return false;
            };
            if (tryStart()) return;
            const mo = new MutationObserver(() => { if (tryStart()) mo.disconnect(); });
            mo.observe(document.documentElement, { childList: true, subtree: true });
        }

        // Dispatch hover-like events to multiple probable nodes
        function emit(root, names) {
            const targets = [
                root,
                root.querySelector('.jdgm-carousel'),
                root.querySelector('.jdgm-carousel__item-container'),
                root.querySelector('.jdgm-carousel__item-wrapper')
            ].filter(Boolean);

            for (const t of targets) {
                for (const name of names) {
                    const bubbles = name === 'mouseover' || name === 'mouseout';
                    const evt = new MouseEvent(name, { bubbles, cancelable: true });
                    t.dispatchEvent(evt); // isTrusted === false (synthetic)
                }
            }
        }

        whenReady((root) => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'jdgm-carousel-toggle toggle-flicky-btn';
            btn.setAttribute('aria-label', 'Pause carousel autoplay');

            (root).prepend(btn);

            let paused = false;

            // Block *real* hover events while paused, but allow synthetic ones
            const blocker = (e) => {
                if (!paused) return;
                if (e.isTrusted) { // real mouse event: swallow it
                    e.stopImmediatePropagation();
                    e.preventDefault();
                }
            };
            const addBlockers = () => ALL_HOVER.forEach(n => root.addEventListener(n, blocker, true));
            const removeBlockers = () => ALL_HOVER.forEach(n => root.removeEventListener(n, blocker, true));

            function updateUI() {
                const ICONS = {
                    play: `
                        <svg aria-hidden="true" viewBox="0 0 24 24" width="20" height="20">
                        <path d="M8 5v14l11-7-11-7z"></path>
                        </svg>`,
                    pause: `
                        <svg aria-hidden="true" viewBox="0 0 24 24" width="20" height="20">
                        <path d="M6 5h4v14H6zM14 5h4v14h-4z"></path>
                        </svg>`
                };

                btn.innerHTML = paused ? ICONS.play : ICONS.pause;
                btn.setAttribute('aria-label', paused ? 'Resume carousel autoplay' : 'Pause carousel autoplay');
                root.classList.toggle('is-paused-by-button', paused);
                const invisibleAlertSecond = document.querySelector('#invisible-alert');
                if (paused) {
                    invisibleAlertSecond.removeAttribute('aria-hidden');
                } else {
                    invisibleAlertSecond.setAttribute('aria-hidden', 'true');
                    invisibleAlertSecond.innerHTML = '';
                }
            }

            function pause() {
                paused = true;
                addBlockers();
                emit(root, E_HOVER_IN);
                updateUI();
            }

            function play() {
                paused = false;
                removeBlockers();
                emit(root, E_HOVER_OUT);
                updateUI();
            }

            btn.addEventListener('click', () => (paused ? play() : pause()));
            btn.addEventListener('keydown', (e) => {
                if (e.key === ' ' || e.key === 'Enter') {
                    e.preventDefault();
                    paused ? play() : pause();
                }
            });

            // start in playing state
            updateUI();

        });
    }
    fixJudgeMeCarousel();

    function fixCart() {
        if (!window.location.pathname.includes('/cart')) return;

        document.querySelectorAll('.cart_items .cart_item').forEach(item => {
            const links = item.querySelectorAll('.cart_items a:has(img), .cart_items .mini_cart_title a');

            if (links.length > 1) {
                replaceLinkWithSpan(links[0], links[1]).setAttribute('aria-hidden', 'true');
            }
        });

        setTimeout(() => {
            document.querySelectorAll('#ws_help img').forEach(img => {
                img.setAttribute('alt', '');
            })
        }, 2000);
    }

    fixCart();

    function fix() {
        let outerContainer = document.querySelector('#boost-sd__search-widget-init-wrapper');
        let innerObserver;
        let linkElements = [];

        function initLinks() {
            if (!outerContainer) return;
            const innerContainer = outerContainer.querySelector('.boost-sd__instant-search-results');
            if (!innerContainer) return;

            linkElements = [...innerContainer.querySelectorAll('a')];

            // Reset tabindex
            linkElements.forEach((link, i) => {
                link.setAttribute('tabindex', i === 0 ? '0' : '-1');
            });

            if (linkElements[0]) linkElements[0].focus();
        }

        function handleArrowNavigation(e) {
            // Only respond to arrows
            if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;

            const active = document.activeElement;
            const currentIndex = linkElements.indexOf(active);

            // If no link is focused yet (like when typing), start from first link
            if (currentIndex === -1 && linkElements.length > 0) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    updateFocus(linkElements[0]);
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    updateFocus(linkElements.at(-1));
                }
                return;
            }

            // Normal navigation between links
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                const next = linkElements[currentIndex + 1] || linkElements[0];
                updateFocus(next);
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                const prev = linkElements[currentIndex - 1] || linkElements.at(-1);
                updateFocus(prev);
            }
        }

        function updateFocus(el) {
            linkElements.forEach(link => link.setAttribute('tabindex', '-1'));
            el.setAttribute('tabindex', '0');
            el.focus();
        }

        // Wait for outer container if it doesn't exist yet
        if (!outerContainer) {
            const waitOuter = new MutationObserver(() => {
                outerContainer = document.querySelector('#boost-sd__search-widget-init-wrapper');
                if (outerContainer) {
                    initOuterObserver();
                    waitOuter.disconnect();
                }
            });

            waitOuter.observe(document.body, { childList: true, subtree: true });
        } else {
            initOuterObserver();
        }

        function initOuterObserver() {
            innerObserver = new MutationObserver(() => {
                setTimeout(initLinks, 50);
            });

            innerObserver.observe(outerContainer, { childList: true, subtree: true });

            initLinks();
        }

        document.addEventListener('keydown', handleArrowNavigation);
    }

    function fixSearchInput() {
        const selectors = '.js_iput_search, .search_header__input';

        function applyObserver(search) {
            if (search.dataset.fixApplied) return;
            search.dataset.fixApplied = 'true';


            const observer = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
                        search.removeAttribute('aria-expanded');
                        if (search.hasAttribute('role')) {
                            search.removeAttribute('role');
                        }
                        document.querySelectorAll('h3.boost-sd__header-item').forEach(h3 => {
                            const h2 = document.createElement('h2');
                            copyAttributes(h3, h2);
                            h2.innerText = h3.innerText;
                            h2.tabIndex = '-1';
                            h2.removeAttribute('role');
                            h3.replaceWith(h2);
                        })
                    }
                });
            });

            observer.observe(search, {
                attributes: true,
                attributeFilter: ['aria-expanded'],
            });
        }

        document.querySelectorAll(selectors).forEach(applyObserver);

        const bodyObserver = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) {
                        if (node.matches(selectors)) {
                            applyObserver(node);
                        }

                        node.querySelectorAll?.(selectors).forEach(applyObserver);
                    }
                });
            });
        });

        bodyObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    fixSearchInput();

    function listSemanticsToFaqAccordion() {
        const accordionContainer = document.querySelector('.dib-faq');
        if (!accordionContainer) return;

        const newContainerList = document.createElement('div');
        newContainerList.setAttribute('role', 'list');
        const heading = accordionContainer.querySelector('.dib-faq-heading');

        if (heading) {
            const newHeading = document.createElement('div');
            copyAttributes(heading, newHeading);
            newHeading.innerText = heading.innerText;
            heading.replaceWith(newHeading);
        }

        accordionContainer.querySelectorAll('.dib-faq-item').forEach(item => {
            const newListItem = document.createElement('div');
            newListItem.setAttribute('role', 'listitem');
            newListItem.appendChild(item);
            newContainerList.appendChild(newListItem);
        });

        accordionContainer.appendChild(newContainerList);
    }

    listSemanticsToFaqAccordion();

    function fixRedundantLinkTextColumnWithImages() {
        if (window.location.pathname.includes('/design-consultations')) return;
        document.querySelectorAll('.cat_space_item').forEach(element => {
            const links = element.querySelectorAll('a');
            if (links.length > 1) {
                const ommit = links[0].classList.contains('ommit_hidden')
                const newSpan = replaceLinkWithSpan(links[0], links[1]);
                if(!ommit) {
                    newSpan.setAttribute('aria-hidden', 'true');
                }
                
                newSpan.removeAttribute('aria-label');
            }
        });
    }

    fixRedundantLinkTextColumnWithImages();

    function fixAddresses() {
        document.querySelectorAll('.sp-myaccount-content li .address').forEach(address => {
            const addressContent = address.querySelector('.content p');
            if (addressContent) {
                const items = addressContent.innerHTML
                    .split(/<br[^>]*>/)
                    .map(item => item.trim())
                    .filter(item => item.length > 0)
                    .map(item => item.replace(/<[^>]*>/g, ''));

                addressContent.innerHTML = '';
                items.forEach((element, index) => {
                    const div = document.createElement('div');
                    div.innerText = element;
                    if (index === 0) {
                        const parent = addressContent.parentNode;
                        const id = parent.getAttribute('data-id');
                        div.id = id;
                    }
                    addressContent.appendChild(div);

                });
            }
        });
    }

    fixAddresses();

    function fixVariant() {
        const observer = new MutationObserver(() => {
            const variant = document.querySelector('variant-swatch-king .swatch-single');
            if (!variant) return;
            const labelHidden = variant.querySelector('.swatch-label-container');
            if (labelHidden) {
                labelHidden.remove();
            }

            const radios = document.querySelectorAll('.swatch-view-item[role="radio"]');
            let selected = Array.from(radios).find(r => r.getAttribute('aria-checked') === 'true');

            // Ensure only one has tabindex=0
            radios.forEach(r => r.tabIndex = r === selected ? 0 : -1);

            radios.forEach((radio, index) => {
                radio.addEventListener('click', () => selectRadio(radio));
                radio.addEventListener('keydown', (e) => handleKey(e, index));
            });

            function selectRadio(radio) {
                radios.forEach(r => {
                    r.tabIndex = -1;
                });
                radio.tabIndex = 0;
                radio.focus();
                radio.click();
            }

            function handleKey(e, index) {
                const { key } = e;
                let newIndex = null;

                if (key === 'ArrowRight' || key === 'ArrowDown') newIndex = (index + 1) % radios.length;
                if (key === 'ArrowLeft' || key === 'ArrowUp') newIndex = (index - 1 + radios.length) % radios.length;

                if (newIndex !== null) {
                    e.preventDefault();
                    selectRadio(radios[newIndex]);
                }
            }
            observer.disconnect();
        });

        observer.observe(document.body, {
            subtree: true,
            childList: true
        })
    }

    // fixVariant();

    function videoPlayPauseButton() {
        const video = document.querySelector('.dib-gif');
        const btn = document.querySelector('.video-btn');
        if (!video) return;
        const playIcon = btn.querySelector('.play-icon');
        const pauseIcon = btn.querySelector('.pause-icon');


        btn.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                playIcon.style.display = 'none';
                pauseIcon.style.display = 'block';
                btn.setAttribute('aria-label', 'Pause video');
            } else {
                video.pause();
                playIcon.style.display = 'block';
                pauseIcon.style.display = 'none';
                btn.setAttribute('aria-label', 'Play video');
            }
        });
    }

    videoPlayPauseButton();

    function findAndFixRedundantLinks() {
        const groupedLinks = groupLinksByHref();
        processLinkGroups(groupedLinks);
    }

    function groupLinksByHref() {
        const allLinks = document.querySelectorAll('.dib-post-content a');
        const urlGroups = {};

        allLinks.forEach(link => {
            const url = link.href;
            if (!urlGroups[url]) {
                urlGroups[url] = [];
            }
            urlGroups[url].push(link);
        });

        return urlGroups;
    }

    function processLinkGroups(groups) {
        for (const url in groups) {
            const elements = groups[url];

            if (elements.length < 2) {
                continue;
            }

            const imageLinks = [];
            const nonImageLinks = [];

            elements.forEach(link => {
                if (link.querySelector('img')) {
                    imageLinks.push(link);
                } else {
                    nonImageLinks.push(link);
                }
            });

            if (imageLinks.length > 0 && nonImageLinks.length > 0) {
                imageLinks.forEach(link => {
                    neutralizeLink(link);
                });
            }
        }
    }

    function neutralizeLink(link) {

        const span = document.createElement('span');


        span.innerHTML = link.innerHTML;
        if (link.className) span.className = link.className;
        if (link.id) span.id = link.id;
        if (link.style.cssText) span.style.cssText = link.style.cssText;

        span.style.cursor = 'pointer';

        // 4. Add the click event to stop navigation
        span.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            window.location.href = link.href;
        });

        if (link.parentNode) {
            link.parentNode.replaceChild(span, link);
        }
    }
    findAndFixRedundantLinks();

    function listenToNavItemsSubmenu() {
        const nav = document.querySelector('.nt_navigation');
        if(!nav) return;
        const parentObserver = new MutationObserver(() => {
            const navItems = nav.querySelectorAll('.tmenu_nav > .tmenu_item');
            
            if(!navItems.length) return;
            navItems.forEach(li => {
                const firstLink = li.querySelector('a')

                if(firstLink) {
                    firstLink.removeAttribute('title');
                    firstLink.removeAttribute('href')
                    firstLink.setAttribute('tabindex', '0');
                    firstLink.removeAttribute('role');
                }
                tabListOnMenu(li);
                const observer = new MutationObserver(() => {
                    const isActive = li.classList.contains('tmenu_item_active');
                    if (isActive) {
                        setTimeout(() => tabListOnMenu(li), 100);
                    }
                });

                observer.observe(li, { attributes: true, attributeFilter: ['class'] });
            });
        });
        parentObserver.observe(nav, {subtree: true, childList: true})
    }

    listenToNavItemsSubmenu();

    function tabListOnMenu(element) {
        const menuWithoutSubLinks = element.querySelector('.tmenu_submenu_type_mega');
        if(menuWithoutSubLinks) {
            menuWithoutSubLinks.querySelectorAll(':scope > li').forEach(item => item.setAttribute('role', 'none'))
            menuWithoutSubLinks.querySelectorAll('a, img').forEach(item => {
                item.removeAttribute('title');
            });
        }

        const parent = element.querySelector('.tmenu_submenu_type_tab');
        if (!parent) return;

        parent.querySelectorAll('.tmenu_item_display_header, .tmenu_item_layout_image, .tmenu_submenu:not(.tmenu_submenu_type_automatic)').forEach(item => {
            item.setAttribute('role', 'none');
        })

        parent.querySelectorAll('.tmenu_item_display_header a, .tmenu_item_layout_image a, .tmenu_submenu a:not([role="tab"])').forEach(item => {
            item.removeAttribute('role');
        })

        if(element.getAttribute('applied') === 'true') return;
        element.setAttribute('applied','true');

        element.querySelectorAll('.tmenu_submenu_heading a').forEach(link => {
            link.removeAttribute('href');
        });

        parent.querySelectorAll('a, img').forEach(item => {
            item.removeAttribute('title');
        });

        const tabList = parent.querySelector(".tmenu_submenu_tab_control");
        tabList.setAttribute("role", "tablist");

        const tabs = [...tabList.querySelectorAll("[data-tab-id]")];
        tabs.forEach(tab => {
            tab.removeAttribute('href');
            tab.setAttribute("role", "tab");
            tab.setAttribute("aria-controls", tab.dataset.tabId);
        });

        /* ---------------------- Helpers ---------------------- */

        function emitHoverEvent(tab) {
            const evt = new MouseEvent('mouseenter', {
                bubbles: true,
                cancelable: true
            });
            evt.synthetic = true;
            tab.dispatchEvent(evt);
        }

        function hideAllSubElements() {
            document.querySelectorAll('.tmenu_submenu_tab_item').forEach(submenu => {
                submenu.setAttribute('aria-hidden', 'true');
                submenu.querySelectorAll('a').forEach(link => link.tabIndex = '-1');
            });
        }

        function showActiveSubElements(id) {
            const ul = document.querySelector(`ul[data-id="${id}"]`);
            const parent = ul.closest('.tmenu_submenu_tab_item')
            parent.removeAttribute('aria-hidden');
            parent.querySelectorAll('a').forEach(link => link.tabIndex = '0');
        }

        function activateTab(tab) {
            tabs.forEach(t => {
                const li = t.closest("li");
                t.setAttribute("tabindex", "-1");
                t.setAttribute("aria-selected", "false");
                li.classList.remove("tmenu_submenu_tab_active");
            });

            const li = tab.closest("li");
            tab.setAttribute("tabindex", "0");
            tab.setAttribute("aria-selected", "true");
            li.classList.add("tmenu_submenu_tab_active");

            tab.focus();
            emitHoverEvent(tab);
            hideAllSubElements();
            showActiveSubElements(tab.getAttribute('data-tab-id'));
        }

        /* ---------------------- EVENT HANDLERS ---------------------- */

        function onClickTab() { activateTab(this); }
        function onHoverTab(e) {
            if (e.synthetic) return;
            emitHoverEvent(this);
        }

        function onKeyTabList(e) {
            const currentIndex = tabs.indexOf(document.activeElement);
            if (currentIndex === -1) return;

            let next = null;
            switch (e.key) {
                case "ArrowRight":
                case "ArrowDown":
                    next = tabs[currentIndex + 1] || tabs[0]; break;
                case "ArrowLeft":
                case "ArrowUp":
                    next = tabs[currentIndex - 1] || tabs[tabs.length - 1]; break;
                case "Home":
                    next = tabs[0]; break;
                case "End":
                    next = tabs[tabs.length - 1]; break;
            }

            if (next) {
                e.preventDefault();
                activateTab(next);
            }
        }

        /* ---------------------- INIT + SAFE LISTENERS ---------------------- */

        // Initial active tab
        const current = tabList.querySelector(".tmenu_submenu_tab_active [data-tab-id]");
        activateTab(current);

        tabs.forEach(t => {
            t.removeEventListener("click", onClickTab);
            t.removeEventListener("mouseenter", onHoverTab);

            t.addEventListener("click", onClickTab);
            t.addEventListener("mouseenter", onHoverTab);
        });

        tabList.removeEventListener("keydown", onKeyTabList);
        tabList.addEventListener("keydown", onKeyTabList);
    }


    function addLabelToCaptcha() {
        const observer = new MutationObserver(() => {
            const textAreas = document.querySelectorAll('[id^="g-recaptcha-response"], [id^="h-captcha-response"]');
            if (textAreas.length > 0) {
                textAreas.forEach(item => appendNewLabel(item, '-'));
                const parent = textAreas[0].parentNode;
                parent.setAttribute('aria-hidden', 'true');
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
        subtree: true,
        childList: true
        });

        function appendNewLabel(element, divider) {
            const name = element.getAttribute('name').split(divider).join(' ');

            const newLabel = document.createElement('label');
            newLabel.className = 'visually-hidden';
            newLabel.innerText = name;
            newLabel.setAttribute('for', element.id);
            element.parentNode.insertBefore(newLabel, element);
        }
    }

    addLabelToCaptcha();

    function convertDuplicateHomeLinks() {
        const homepagePatterns = [
            '/',
            window.location.origin + '/',
            window.location.origin
        ];

        // Find all <a> whose href matches homepage
        const links = Array.from(document.querySelectorAll('a')).filter(a => {
            const href = a.getAttribute('href');
            if (!homepagePatterns.includes(href)) return false;

            if (a.id === 'nt_backtop' || a.classList.contains('compare_remove')) return false;

            return true;
        });

        if (links.length <= 1) return;

        const [keepLink, ...duplicates] = links;

        duplicates.forEach(link => {
            const url = link.getAttribute('href');

            link.style.cursor = 'pointer';
            link.tabIndex = 0;
            link.removeAttribute('href');

            link.addEventListener('click', () => {
            window.location.href = url;
            });

            link.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                window.location.href = url;
            }
            });
        });
    }
    convertDuplicateHomeLinks();

    function removeAllNoScript() {
        document.querySelectorAll('noscript').forEach(ns => ns.remove());
    }
    removeAllNoScript();

    function addAriaHiddenToStyles() {
        // Apply to all existing <style> tags
        document.querySelectorAll('style').forEach(style => {
            style.setAttribute('aria-hidden', 'true');
        });

        // Observe for newly added <style> tags
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.tagName === 'STYLE') {
                        node.setAttribute('aria-hidden', 'true');
                    }

                    // Handle <style> inside fragments (e.g. <div> with inner styles)
                    if (node.querySelectorAll) {
                        node.querySelectorAll('style').forEach(style => {
                            style.setAttribute('aria-hidden', 'true');
                        });
                    }
                });
            });
        });

        // Watch the entire document for changes
        observer.observe(document.documentElement, {
            childList: true,
            subtree: true
        });
    }
    addAriaHiddenToStyles();

    function listSemanticsToCollectionPackery() {
        const cols = document.querySelectorAll('.nt_cats_holder > div');
        if(cols.length > 1) {
            const defaultItem = cols[0];
            const defaultRow = defaultItem.querySelector('.row');
            defaultRow.setAttribute('role', 'list');
            defaultRow.querySelectorAll('.cat_grid_item').forEach(rowItem => {
                rowItem.setAttribute('role', 'listitem');
            });
            cols.forEach((item, index) => {

                if(index !== 0) {
                    item.querySelectorAll('.cat_grid_item').forEach(rowItem => {
                        rowItem.setAttribute('role', 'listitem');
                        defaultRow.appendChild(rowItem);
                    });
                    item.remove();
                }
            });
        }
    }
    // listSemanticsToCollectionPackery();

    function hideEmptyIFRAME() {
        const container = document.querySelector('#tr0uASogjCtqQMRo1ZGpRw');
        if(container) {
            const parent = container.closest('.shopify-section');
            const observer = new MutationObserver(() => {
                const iframe = container.querySelector('iframe');
                if(!iframe) return;
                iframe.setAttribute('aria-hidden', 'true');
                observer.disconnect();
            });
            observer.observe(parent, {subtree: true, childList: true});
            parent.setAttribute('aria-hidden', 'true');
        }
    }

    hideEmptyIFRAME();

    function formErrorLogin() {
        if (!window.location.pathname.includes('/account')) return;

        new MutationObserver(() => {
            const errorMessage = document.querySelector('.form-message--error:not([applied])');
            if(!errorMessage) return;
            errorMessage.setAttribute('role', 'alert');
        }).observe(document.body, {subtree: true, childList: true});
    }

    formErrorLogin();

    function listSemanticsToFooterItemsOnMobile() {
        const isMobile = window.innerWidth < 768;
        if(isMobile) {
            const row = document.querySelector('.footer__top_wrap .row');
            if(row) {
                row.setAttribute('role', 'list');
                row.querySelectorAll(':scope > div').forEach(item => {
                    item.setAttribute('role', 'listitem');
                    const accordionBtn = item.querySelector(':scope .widget-title');
                    accordionBtn.setAttribute('aria-expanded', 'false')
                    accordionBtn.setAttribute('role', 'button');
                    accordionBtn.setAttribute('tabindex', '0');
                    accordionBtn.addEventListener('keydown', (e) => {
                        if(e.key === 'Enter') accordionBtn.click();
                    });
                    accordionBtn.addEventListener('click', () => {
                        const parent = accordionBtn.closest('.widget')
                        setTimeout(() => {
                            accordionBtn.setAttribute('aria-expanded', parent.classList.contains('footer_opened').toString())
                        }, 100);
                    });
                })
            }
        }
    }

    listSemanticsToFooterItemsOnMobile();

    function focusTrapToSearchModal() {
        const searchBtn = document.querySelector('[data-id="#nt_search_canvas"]');
        if (searchBtn) {
            const listener = () => {
                setTimeout(() => {
                    const canvas = document.querySelector('#nt_search_canvas');
                    if (canvas) {
                        canvas.removeAttribute('aria-hidden')
                        canvas.querySelector('.iccl.iccl-search').removeAttribute('tabindex')
                        trapFocusReuse(canvas, searchBtn);
                    }
                }, 300);
            }
            searchBtn.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') listener();
            })

            searchBtn.addEventListener('click', () => listener())
        }
    }

    focusTrapToSearchModal();

    function fixHeadingComparePage() {
        const isWishView = location.search.includes('view=compe');
        if (!isWishView) return;

        const h1 = document.querySelector('#nt_content h1');

        if (!h1) {
            const texts = document.querySelectorAll('#nt_content .container p');
            if (texts.length > 1) {
                const newH1 = document.createElement('h1');
                newH1.innerText = texts[1].innerText;
                newH1.style.fontSize = '14px';
                newH1.style.color = '#fff';
                texts[1].replaceWith(newH1);
            }
        }
    }

    fixHeadingComparePage();

    function listenToQuickViewCollection() {
        document.addEventListener('click', (e) => {
        const btn = e.target.closest('.boost-sd__button--quick-view');
        if (!btn) return;

        setTimeout(() => {
            const modal = document.querySelector('#boost-sd__modal-quickview');
            if(!modal) return
            
            const title = modal.querySelector('.boost-sd__quick-view-title');
            if(title) {
                const h1 = document.createElement('h1');
                h1.innerText = title.innerText;
                h1.className = title.className;
                title.replaceWith(h1);
            }

            const rating = modal.querySelector('.jdgm-prev-badge__stars');
            if(rating) {
                rating.setAttribute('aria-label', `${rating.getAttribute('data-score')} out of 5 stars`);
                rating.setAttribute('role', 'img');
                rating.removeAttribute('tabindex');
            }

            const btnImgs = modal.querySelectorAll('.boost-sd__product-image[tabindex]');
            btnImgs.forEach((btn, index) => {
                btn.setAttribute('aria-label', `View product image ${index + 1} of ${btnImgs.length}`);
                btn.setAttribute('role', 'button');
                const parent = btn.closest('.boost-sd__thumbs-container-thumbs-item');
                btn.setAttribute('aria-pressed', parent.classList.contains('boost-sd__thumbs-container-thumbs-item--selected').toString())
                btn.addEventListener('click', () => {
                    setTimeout(() => {
                        btnImgs.forEach(imageBtn => imageBtn.setAttribute('aria-pressed', 'false'));
                        btn.setAttribute('aria-pressed', parent.classList.contains('boost-sd__thumbs-container-thumbs-item--selected').toString())
                    }, 200);
                });
            })
        }, 500);
        });
    }
    listenToQuickViewCollection();

    function quickViewProcAccess() {
        document.addEventListener('click', (e) => {
            const btn = e.target.closest('.sg-pro-access-quick-view-btn');
            if (!btn) return;

            setTimeout(() => {

                const modal = document.querySelector('.spicegems-product-quickview');
                if (!modal) return

                const title = modal.querySelector('.spicegems-product-title');
                if (title) {
                    const h1 = document.createElement('h1');
                    h1.innerText = title.innerText;
                    h1.className = title.className;
                    title.replaceWith(h1);
                }

                const close = modal.querySelector('.spicegems-modal-close');
                if (close) {
                    close.setAttribute('aria-label', 'Close');

                }

                const viewDetails = modal.querySelector('#spicegems-view-full-details');
                if (viewDetails) {
                    viewDetails.tabIndex = '0'
                    viewDetails.role = "button";
                    viewDetails.addEventListener('keydown', (e) => {
                        if (e.key === 'Enter') {
                            viewDetails.click();
                        }
                    });
                }

                const listBtns = document.querySelector('.spicegems-carousel-indicators');
                if (listBtns) {
                    listBtns.setAttribute('role', 'none');
                    const items = listBtns.querySelectorAll('li');
                    items.forEach((li, index) => {
                        li.setAttribute('role', 'button');
                        li.setAttribute('tabindex', '0');
                        li.setAttribute('aria-pressed', li.classList.contains('active') ? 'true' : 'false');
                        li.setAttribute('aria-label', `View product image ${index + 1} of ${items.length}`);
                        li.addEventListener('keydown', (e) => {
                            if (e.key === 'Enter') {
                                li.click();
                                setTimeout(() => {
                                    items.forEach(element => {
                                        element.setAttribute('aria-pressed', 'false');
                                    });
                                    li.setAttribute('aria-pressed', li.classList.contains('active') ? 'true' : 'false');
                                }, 300);
                            }
                        });
                    })
                }

                modal.setAttribute('aria-modal', 'true');
                modal.setAttribute('role', 'dialog');
                trapFocusReuse(modal, btn);
            }, 300);
        })
    }

    quickViewProcAccess();

    function updateTabTitleFromH1() {
        if (!window.location.pathname.includes('/a/blog') 
            && !window.location.pathname.includes('/search') 
            && !window.location.pathname.includes('/search') 
            && !window.location.pathname.includes('/apps/parcelpanel')) return;
        const h1 = document.querySelector('h1');
        if (h1) document.title = h1.textContent.trim();
    }
    updateTabTitleFromH1();

    function fixShopTheLookFirstLoad() {
        function setupContainer(container) {
            container.setAttribute('tabindex', '0');
            const isModalActive = window.innerWidth < 1367;
            container.addEventListener('focus', () => {
                const first = container.querySelector(isModalActive ? '[data-opennt]' : '.pin_tt_js')
                if (first) {
                    first.tabIndex = 0;
                    first.focus();
                    container.removeAttribute('tabindex');
                }
            });
        }

        const container = document.querySelector('.js_packery:has(.pin_tt)');
        if (container) {
            setupContainer(container);
        }

    }

    fixShopTheLookFirstLoad();

    function fixPackery() {
        document.querySelectorAll('.nt_cats_holder').forEach(item => {
            const size = item.getAttribute('size');
            if (!size) return
            const items = item.querySelectorAll('.cat_grid_item');
            item.innerHTML = '';
            item.classList.add(`grid-${size}`)
            item.setAttribute('role', 'list');
            items.forEach(cat => {
                const contentContainer = cat.querySelector('.cat_grid_item__wrapper');

                if(contentContainer) {
                    contentContainer.setAttribute('aria-hidden', 'true');
                    const link = cat.querySelector('.cat_grid_item__link');
                    const title = contentContainer.querySelector('.cat_grid_item__title');
                    const count = contentContainer.querySelector('.cat_grid_item__count');
                    link.setAttribute('aria-label', title.innerText);
                    link.setAttribute('aria-description', count.innerText);
                }

                cat.setAttribute('role', 'listitem');
                cat.classList.remove('col-6', 'col-md-12', 'col-md-6', 'col-12', 'col-md-3');
                item.appendChild(cat);
            });
        });
    }

    fixPackery();

    function filterPopupFix() {
        document.addEventListener('click', (event) => {
            const button = event.target.closest('#boost-sd__filter-tree-toggle-button');
            if (!button) return;

            const dialog = document.querySelector('#boost-sd_filter-tree-mobile');
            if(!dialog) return;
            addModalSemantics(dialog);

    })

            new MutationObserver(() => {
            const modal = document.querySelector('#boost-sd_filter-tree-mobile');
                
            if(modal && !modal.querySelector('role')) {
                addModalSemantics(modal);
            }
        }).observe(document.body, {
                subtree: true,
                childList: true
        })

    function addModalSemantics(modal) {
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-label', 'Filters');
        const trap = createFocusTrap(modal);
        trap.activate();
        const closeBtn = modal.querySelector('.boost-sd__button');
        if(closeBtn) {
            modal.addEventListener('keydown', (e) => {
                if(e.key === 'Escape') {
                    closeBtn.click();
                }
            });
        }

        modal.querySelectorAll('.boost-sd__button--back').forEach(back => {
            back.setAttribute('aria-label', 'Back');
        });

        modal.querySelectorAll('.boost-sd__filter-option-title').forEach(filter => {
            filter.setAttribute('aria-expanded', 'false');
        });

        document.addEventListener('click', e => {
            if (e.target.closest('.boost-sd__filter-option-title') || e.target.closest('.boost-sd__button--back')) {
                trap.update(); // ✅ recompute focusables
            }
        });
    }


        function createFocusTrap(container) {
            let focusable = [];
            let first = null;
            let last = null;
            let active = false;

            function update() {
                focusable = Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR))
                .filter(el => !el.hasAttribute('aria-hidden'));

                first = focusable[0] || null;
                last = focusable[focusable.length - 1] || null;
                focusable[0]?.focus();
            }

            function onKeydown(e) {
                if (!active || e.key !== 'Tab' || !first || !last) return;

                if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
                } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
                }
            }

            function activate() {
                if (active) return;
                update();
                container.addEventListener('keydown', onKeydown);
                active = true;
            }

            function deactivate() {
                if (!active) return;
                container.removeEventListener('keydown', onKeydown);
                active = false;
            }

            return {
                activate,
                deactivate,
                update
            };
        }



        const FOCUSABLE_SELECTOR = `
        a[href]:not([tabindex="-1"]),
        button:not([disabled]):not([tabindex="-1"]),
        input:not([disabled]):not([type="hidden"]):not([tabindex="-1"]),
        select:not([disabled]):not([tabindex="-1"]),
        textarea:not([disabled]):not([tabindex="-1"]),
        [tabindex]:not([tabindex="-1"])
        `;




    }

filterPopupFix();

function addAccessibleNameToIframe() {
    const observer = new MutationObserver(() => {
        const iframe = document.querySelector('iframe[ng-non-bindable]');
        if(iframe) {
            iframe.setAttribute('aria-label', 'Announcement');
            observer.disconnect();
        }
    })

    observer.observe(document.body, {
        subtree: true,
        childList: true
    })
}

addAccessibleNameToIframe();


(function () {
    function onTidioChatApiReady() {
        new MutationObserver(() => {
            const chat = document.querySelector('.chat');
            if (!chat) return;

            focusTrap(chat);
            focusFirstElementOnEmojies(chat);
            hiddenElements(chat);

        }).observe(document.body, {
            subtree: true,
            childList: true
        })
    }
    if (window.tidioChatApi) {
        window.tidioChatApi.on('ready', onTidioChatApiReady);
    } else {
        document.addEventListener('tidioChat-ready', onTidioChatApiReady);
    }

    function chatElements(container) {
        const observer = new MutationObserver(() => {
            const messagesContainer = container.querySelector('#messages');
            if (!messagesContainer) return;

            messagesContainer.querySelectorAll('.message-operator, .message-visitor')
                .forEach(element => updateChatItem(element));

            const newChatItemObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === 1) {
                            updateChatItem(node);
                        }
                    });
                });
            });

            newChatItemObserver.observe(messagesContainer, {
                childList: true,
                subtree: true
            });


            observer.disconnect();
        });
        observer.observe(container, {
            subtree: true,
            childList: true
        })

        function updateChatItem(node) {
            const hiddenText = document.createElement('span');
            hiddenText.classList.add('visually-hidden');

            if (node.classList.contains('message-operator')) {
                hiddenText.innerText = 'Representative: ';
                node.prepend(hiddenText);
                const btnsLabel = ['Very Bad', 'Bad', 'Neutral', 'Good', 'Very Good'];
                node.querySelectorAll('button').forEach((btn, index) => {
                    btn.setAttribute('aria-label', btnsLabel[index]);
                });
            } else if (node.classList.contains('message-visitor')) {
                hiddenText.innerText = 'You: ';
                node.prepend(hiddenText);
            }
        }
    }

    function trapFocus(container, btnOpenModal) {
        const focusables = getFocusableElements(container);

        if (focusables.length === 0) return;

        // Focus first element
        focusables[0].focus();

        container.addEventListener('keydown', (e) => {
            if (e.key !== 'Tab') return;

            const first = focusables[0];
            const last = focusables[focusables.length - 1];

            if (e.shiftKey) {
                if (document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                if (document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        });

        const offEscape = onEscape(() => {
            if (btnOpenModal) {
                btnOpenModal.focus();
            }
        });

        function onEscape(handler) {
            function listener(e) {
                if (e.key === 'Escape' || e.key === 'Esc' || e.code === 'Escape') {
                    handler(e);
                }
            }
            container.addEventListener('keydown', listener);
            return () => container.removeEventListener('keydown', listener);
        }
    }

    function hiddenElements(container) {
        
        const observer = new MutationObserver(() => {
            const hiddenElementsContainer = container.querySelector('.drag-active-wrapper');
            if(!hiddenElementsContainer) return;
        
        new MutationObserver(() => {
            const isHidden = hiddenElementsContainer.classList.contains('hidden');
            hiddenElementsContainer.querySelectorAll('button, textarea, input').forEach(item => {
                item.setAttribute('aria-hidden', isHidden ? 'true' : 'false');
                isHidden ? item.setAttribute('tabindex', '-1') :  item.removeAttribute('tabindex');
            });
            
            }).observe(hiddenElementsContainer, { attributes: true, attributeFilter: ['class'] });
            observer.disconnect();
        });


        observer.observe(container, {
            subtree: true,
            childList: true
        })
    }

    function getFocusableElements(container) {
        return Array.from(
            container.querySelectorAll(
                `
                            a[href],
                            button:not([disabled]),
                            input:not([disabled]):not([type="hidden"]),
                            select:not([disabled]),
                            textarea:not([disabled]),
                            [tabindex]:not([tabindex="-1"])
                            `
            )
        );
    }
})();


(function () {
  const isMobile = window.innerWidth < 625;
  if(!isMobile) return
  const tablist = document.querySelector('.pp_tracking_tab');
  if (!tablist) return;

  const tabs = Array.from(tablist.querySelectorAll('.pp_tracking_tab_left'));

  // ✅ Stable panels — NO data-v, NO style selectors
  const panelOrder = document.querySelector('.pp_tracking_form_order');
  const panelTracking = document.querySelector('.pp_tracking_form_number');

  const panels = [panelOrder, panelTracking];
  if (tabs.length !== 2 || panels.includes(null)) return;

  // ARIA setup
  tablist.setAttribute('role', 'tablist');

  tabs.forEach((tab, i) => {
    tab.setAttribute('role', 'tab');
    tab.id = `pp-tab-${i}`;
    tab.setAttribute('aria-controls', `pp-panel-${i}`);
    tab.tabIndex = tab.classList.contains('pp_active') ? 0 : -1;
    tab.setAttribute(
      'aria-selected',
      tab.classList.contains('pp_active') ? 'true' : 'false'
    );
  });

  panels.forEach((panel, i) => {
    panel.setAttribute('role', 'tabpanel');
    panel.id = `pp-panel-${i}`;
    panel.setAttribute('aria-labelledby', `pp-tab-${i}`);
    panel.hidden = !tabs[i].classList.contains('pp_active');
  });

  function activateTab(index) {
    tabs.forEach((tab, i) => {
      const selected = i === index;
      tab.classList.toggle('pp_active', selected);
      tab.setAttribute('aria-selected', selected);
      tab.tabIndex = selected ? 0 : -1;
    });

    panels.forEach((panel, i) => {
      panel.hidden = i !== index;
      panel.style.display = i === index ? '' : 'none';
    });

    tabs[index].focus();
    tabs[index].click();
  }

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activateTab(index));

    tab.addEventListener('keydown', (e) => {
      let nextIndex = null;

      switch (e.key) {
        case 'ArrowRight':
          nextIndex = (index + 1) % tabs.length;
          break;
        case 'ArrowLeft':
          nextIndex = (index - 1 + tabs.length) % tabs.length;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = tabs.length - 1;
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          activateTab(index);
          return;
        default:
          return;
      }

      e.preventDefault();
      tabs[nextIndex].focus();
      tabs[nextIndex].click();
    });
  });
})();

});